//src/data/conclaveData.js
import { Cpu, Shield, Bot, Zap, Building, Heart, DollarSign, BookOpen, Users, Briefcase, School, ShieldCheck, Landmark, Lightbulb, Globe, HeartHandshake, Trophy, GraduationCap, Mail, Phone, MapPin, Clock, Rocket } from 'lucide-react';

import Suma_Varughese from '../media/speakers/Varughese.png'
import K_Rajalakshmi_Menon from '../media/speakers/RajalakshmiMenon.png'
import VK_Prafulla_Chandran from '../media/speakers/PrabhullaChandran.png'
import Prahlada_Rama_Rao from '../media/speakers/PrahladaRamaRao.png'
import Kota_Harinarayana from '../media/speakers/KotaHarinarayana.png'
import S_Sadagopan from '../media/speakers/Sadagopan.png';
import Narayana from '../media/speakers/Narayanan.png';
import Jitesh from '../media/speakers/RJoshi.png';
import bhvs from '../media/speakers/NarayanaMurthy.png';
import NavyaIyengar from '../media/speakers/NavyaIyengar.png';
import DrBKDas from '../media/speakers/DrBKDas.png';
import DrSamirVKamat from '../media/speakers/DrSamirVKamat.png';
import AshwinPChandran from '../media/speakers/AshwinPChandran.png';
import DrSathyanarayanaSrikanta from '../media/speakers/DrSathyanarayanaSrikanta.png';
import KavithaSureshKumar from '../media/speakers/KavithaSureshKumar.jpg';
import PoojaYadav from '../media/speakers/PoojaYadav.png';

import Pradeep_Khanna from '../media/speakers/PradeepKhanna.jpg';
import Dileep_Kumar from '../media/speakers/DileepKumar.jpg';
import Shibu_Pillai from '../media/speakers/ShibuPillai.jpg';
import DrAbhayAPashilkar from '../media/speakers/DrAbhayAPashilkar.png';


import Shubhanshu_Shukla from '../media/speakers/Shubhanshu_Shukla.png';
import Tuhin_Sinha from '../media/speakers/Tuhin_Sinha.png';
import Suresh_Sundaram from '../media/speakers/Suresh_Sundaram.png';
import Manickam_R from '../media/speakers/Manickam_R.png';
import Baladitya_Suri from '../media/speakers/Baladitya_Suri.png';
import Lakshmi_Ravishankar from '../media/speakers/Lakshmi_Ravishankar.png';

import DrGopal_Krishna_Patra from '../media/speakers/DrGopal_Krishna_Patra.png';
import DrManju_Nanda from '../media/speakers/DrManju_Nanda.png';
import DrRKRamanathan from '../media/speakers/DrRKRamanathan.png';
import GSathish_Kumar from '../media/speakers/GSathish_Kumar.png';
import Sujith_S from '../media/speakers/Sujith_S.png';

import Vijay_R from '../media/speakers/Vijay_R.png';

import Jayakumar_J from '../media/speakers/Jayakumar_J.png';

import Manish_M from '../media/speakers/Manish_M.png';

import DrJVSatyanarayana from '../media/speakers/DrJVSatyanarayana.png';
import Jithesh_Sachdeva from '../media/speakers/Jithesh_Sachdeva.png';

import Peeyush_Marwaha from '../media/speakers/Peeyush_Marwaha.png';

import DrVenkateswaran_PS from '../media/speakers/DrVenkateswaran_PS.png';

import R_Thogaivani from '../media/speakers/R_Thogaivani.png';


import Brahmos_Logo from '../media/uploads/Brahmos_Logo.png';
import drdo_logo from '../media/uploads/drdo_logo.png';
import IISc_Logo from '../media/uploads/IISc_Logo.png';
import ISRO_Logo from '../media/uploads/ISRO_Logo.png';
import NAL_Logo from '../media/uploads/Banner_NAL.png';
import SKL_Logo from '../media/uploads/SKL_Logo.png';
import CSI_roundLogo from '../media/uploads/CSI_newheader.png';

import Venu_image from '../media/uploads/NSSC_5121.jpg';
import drdo_logo_banner from '../media/uploads/Bannerdrdo.png'

import Banner_BrahMos from '../media/uploads/Banner_BrahMos.png';
// import ivetc from '../media/uploads/ivetc.png';
import ivetc from '../media/uploads/ivetc_900px.png';

import bannerisro from '../media/uploads/bannerisro.png';
//import aboutvideo from '../media/uploads/about.gif';
import EDC from '../media/uploads/EDC.png';
import Exotyq from '../media/uploads/Exotyq.png';
import Taurus from '../media/uploads/Taurus.png';
import Day1 from '../media/uploads/Day1.png';
import Day2 from '../media/uploads/Day2.png';
import Day3 from '../media/uploads/Day3.png';
import Startup1 from '../media/uploads/Startup1.png'
import Startup2 from '../media/uploads/Startup2.png'
import Startup3 from '../media/uploads/Startup3.png'
import Startup4 from '../media/uploads/Startup4.png'
import Startup5 from '../media/uploads/Startup5.png'
import Startup6 from '../media/uploads/Startup6.png'
import Startup7 from '../media/uploads/Startup7.png'
import venueImg from '../media/uploads/TajMGRoad.jpg';
// import venueImg2 from '../media/uploads/JNTataAuditoriu_2.png';
// import venueImg3 from '../media/uploads/JNTataAuditoriuM.png';
// import venueImg4 from '../media/uploads/IIScBuilding.png';
// import venueImg5 from '../media/uploads/IIScBuilding_2.png';
// import venueImg6 from '../media/uploads/IIScMainGatE.png';
// import Cohosting from '../components/cohostingpartner'
import gifvideo from '../media/uploads/gifvideo.mp4';
import EDC_Exotyq_Taurus from '../media/uploads/EDC_Exotyq_Taurus.png';

// Partner logos

import Partner_LNN_logo from '../media/uploads/Partner_LNN_logo.png';
import Partner_Innefu_logo from '../media/uploads/Partner_Innefu_logo.png';

import Partner_AEROSPACE_Logo from '../media/uploads/Partner_AEROSPACE_Logo.png';
import Partner_BEL_Logo from '../media/uploads/Partner_BEL_Logo.png';
import Partner_CADFEM_Logo from '../media/uploads/Partner_CADFEM_Logo.png';
import Partner_HAL_Logo from '../media/uploads/Partner_HAL_Logo.png';
import Partner_IDFC_Logo from '../media/uploads/Partner_IDFC_Logo.png';
import Partner_Vertotech_Logo from '../media/uploads/Partner_Vertotech_Logo.png';
import Partner_alliance_Logo from '../media/uploads/Partner_alliance_Logo.png';

export const sectionOrder = [

  { name: 'AdvisoryBoardSection', order: 3, display: true },
  { name: 'AboutSection', order: 4, display: true },
  { name: 'ConclaveOverviewSection', order: 5, display: true },
  { name: 'StartupShowcaseSection', order: 6, display: true },
  { name: 'ScheduleSection', order: 7, display: true }, // Make this true to display Schedule in website - Below export const sttcSchedule
  { name: 'PartnerExplorer', order: 8, display: true },

  { name: 'PartnersSection', order: 9, display: true },

  { name: 'GetInvolvedSection', order: 15, display: true },
  { name: 'VenueSection', order: 16, display: true },
  { name: 'Footer', order: 17, display: true },


  // Non displying sections

  { name: 'Cohosting', order: 2, display: false },
  { name: 'PartnersPage', order: 9, display: false },
  { name: 'VisionObjectivesSection', order: 10, display: false },
  { name: 'TechnologyDeepDivesSection', order: 15, display: false },
  { name: 'IndustryVerticalTracksSection', order: 22, display: false },
  { name: 'ParticipantProfileSection', order: 14, display: false },

  { name: 'AgendaSection', order: 7, display: false },  // 

  { name: 'SpeakersSection', order: 22, display: false },

  { name: 'SponsorsSection', order: 12, display: false },
  { name: 'ExhibitorsSection', order: 13, display: false },

  { name: 'ContactSection', order: 16, display: false },

  { name: 'AudienceSection', order: 18, display: false },
  { name: 'FocusAreas', order: 19, display: false },
  { name: 'KeyVerticals', order: 20, display: false },
  { name: 'AudienceMetricsBand', order: 21, display: false },
];

export const navigationMenu = [
  {
    label: 'Home',
    id: 'home',
    display: true,
    order: 1,
    isRoute: false
  },
  {
    label: 'About',
    id: 'about',
    display: true,
    order: 3,
    isRoute: false
  },
  {
    label: 'Thought Leaders',
    id: 'advisory-board',
    display: true,
    order: 2,
    isRoute: false
  },
  {
    label: 'Partners',
    id: 'partners',
    display: false,
    order: 4,
    isRoute: false
  },
  {
    label: 'Get Involved',
    id: 'get-involved',
    display: true,
    order: 5,
    isRoute: false
  },
  {
    label: 'Conclave',
    id: 'conclave-overview',
    display: true,
    order: 3,
    isRoute: false
  },

  {
    label: 'Program',
    id: 'agenda',
    display: false,
    order: 5,
    isRoute: false
  },


  {
    label: 'Exhibitors',
    id: 'exhibitors',
    display: false,
    order: 8,
    isRoute: false
  },
  {
    label: 'Venue',
    id: 'venue',
    display: false,
    order: 9,
    isRoute: false
  },
  {
    label: 'Contact',
    id: 'contact',
    display: false,
    order: 10,
    isRoute: false
  }
];

export const conclaveOverview = {
  display: true,
  heading: "Conclave",

  mainDescription:
    "The Strategic TechTrust Conclave 2026 (STTC 2026) is crafted as an immersive experience, spanning multiple zones and formats, all unified by the TechTrust promise – **Enabling Trust Through Technology.**",

  deepDiveCopy:
    "The **Technology Deep Dives** at STTC 2026 will feature cutting-edge **Emerging Tech Zones**, offering hands-on exploration of AI/ML (including prompt engineering, generative AI, and LLMs), advanced **cybersecurity frameworks** like zero-trust and ethical hacking labs, innovations in **UAVs and robotics** for dual-use and industrial applications, and the future of **quantum computing**, from cryptography to simulation.\n\nRunning parallel to these are the **Industry Vertical Tracks**, featuring **Defence Tech**, which focuses on **indigenous defence systems, advanced warfare technologies, and national security innovations** - all aimed at bridging strategic **defence priorities with emerging technologies**",

  participantHeading: "PARTICIPANT PROFILE",
  participantList: [
    "CEOs, CTOs, and Founders of tech-driven enterprises",
    "DRDO, ISRO, and Defence Forces leadership",
    "Professors and Deans from top technical universities",
    "AI/ML, Cybersecurity, and Quantum Computing professionals",
    "Startup founders, incubators, accelerators",
    "Students and Interns (pre-registered and screened)",
    "CSR Heads and ESG Specialists"
  ],
  rightImage: ivetc,
  // rightHeading:'Strategic Industry Verticals & Emerging Tech Convergence',
  rightHeading: 'Emerging Tech Convergence',

};


// NEW: Technology Deep Dives Section
export const technologyDeepDives = {
  heading: 'Emerging Technologies',
  headingDescription: 'Cutting-edge Emerging Tech Zones offering hands-on exploration',
  content: [
    {
      icon: Cpu,
      title: 'AI/ML',
      description: "Harnessing artificial intelligence and machine learning",
      features: ['Prompt Engineering', 'Generative AI', 'Large Language Models', 'Machine Learning Applications'],
      display: true,
      order: 1
    },
    {
      icon: Shield,
      title: 'Cybersecurity',
      description: "Protecting digital assets and critical infrastructure",
      features: ['Zero-Trust Architecture', 'Ethical Hacking Labs', 'Security Frameworks', 'Threat Intelligence'],
      display: true,
      order: 2
    },
    {
      icon: Bot,
      title: 'UAV / Robotics',
      description: "Advancing aerial innovation across multiple sectors",
      features: ['Autonomous Systems', 'Industrial Robotics', 'Drone Technology', 'Dual-Use Applications'],
      display: true,
      order: 3
    },
    {
      icon: Zap,
      title: 'Quantum Computing',
      description: "Pioneering the next computing frontier",
      features: ['Quantum Cryptography', 'Quantum Simulation', 'Quantum Algorithms', 'Hardware Developments'],
      display: true,
      order: 4
    }
  ],
  display: true
};

// NEW: Industry Vertical Tracks Section
export const industryVerticalTracks = {
  heading: 'Industry Verticals',
  headingDescription: 'Focused sectoral dialogues designed to bridge strategic priorities with emerging technologies',
  content: [
    {
      icon: Shield,
      name: 'DEF-TECH',
      color: 'text-primary',
      description: 'Visualizing smart, autonomous defense for tomorrow',
      focus: ['Defence Systems', 'Warfare Technology', 'Military Innovation', 'Strategic Defence'],
      display: false,
      order: 1
    },
    {
      icon: Building,
      name: 'INFRA-TECH',
      color: 'text-tech-accent',
      description: 'Building smart, sustainable infrastructure for tomorrow',
      focus: ['Smart Cities', 'Infrastructure Resilience', 'Urban Planning', 'Sustainable Development'],
      display: false,
      order: 2
    },
    {
      icon: Heart,
      name: 'HEALTH-TECH',
      color: 'text-success',
      description: 'Revolutionising healthcare delivery and patient outcomes',
      focus: ['Bio-informatics', 'Telehealth', 'Medical Devices', 'Digital Health'],
      display: false,
      order: 3
    },
    {
      icon: DollarSign,
      name: 'BFSI-TECH',
      color: 'text-warning',
      description: 'Creating accessible financial ecosystems for all',
      focus: ['Blockchain Technology', 'Fraud Analytics', 'Fintech Innovation', 'Digital Banking'],
      display: false,
      order: 4
    },
    {
      icon: BookOpen,
      name: 'SKILL-TECH',
      color: 'text-secondary',
      description: 'Transforming learning experiences through technology innovation',
      focus: ['AI-Powered Learning', 'Talent Assessment', 'Skill Development', 'Educational Technology'],
      display: false,
      order: 5
    }
  ],
  display: false,
};

// NEW: Enhanced Participant Profile Section
export const participantProfile = {
  heading: 'Participant Profile',
  headingDescription: 'A diverse ecosystem of leaders, innovators, and emerging talent',
  content: [
    {
      icon: Users,
      title: 'C-Suite Executives',
      description: 'CEOs, CTOs, and Founders of tech-driven enterprises',
      details: ['Technology Leaders', 'Innovation Directors', 'Strategic Decision Makers'],
      display: true,
      order: 1
    },
    {
      icon: ShieldCheck,
      title: 'Defense & Space Leadership',
      description: 'DRDO, ISRO, and Defence Forces leadership',
      details: ['Research Leaders', 'Strategic Planners', 'Defense Technologists'],
      display: true,
      order: 2
    },
    {
      icon: GraduationCap,
      title: 'Academic Leaders',
      description: 'Professors and Deans from top technical universities',
      details: ['Research Directors', 'Department Heads', 'Academic Innovators'],
      display: true,
      order: 3
    },
    {
      icon: Cpu,
      title: 'Tech Professionals',
      description: 'AI/ML, Cybersecurity, and Quantum Computing professionals',
      details: ['Domain Experts', 'Technical Specialists', 'Innovation Engineers'],
      display: true,
      order: 4
    },
    {
      icon: Rocket,
      title: 'Startup Ecosystem',
      description: 'Startup founders, incubators, accelerators',
      details: ['Entrepreneurs', 'Mentors', 'Investors', 'Innovation Catalysts'],
      display: true,
      order: 5
    },
    {
      icon: School,
      title: 'Emerging Talent',
      description: 'Students and Interns (pre-registered and screened)',
      details: ['Engineering Students', 'Research Scholars', 'Young Innovators'],
      display: true,
      order: 6
    },
    {
      icon: Heart,
      title: 'Corporate Responsibility',
      description: 'CSR Heads and ESG Specialists',
      details: ['Sustainability Leaders', 'Social Impact Managers', 'ESG Specialists'],
      display: true,
      order: 7
    }
  ],
  display: true
};

// NEW: Startup Showcase Section
export const startupShowcase = {
  display: true,
  heading: 'Startup Showcase',
  description: 'Featuring handpicked startups from each vertical and from campuses as well, curated by SKILLABLERS in partnership with IISc’s incubation ecosystem and national accelerators will be a game changer.',
  paragraphs: [
    'Featuring handpicked startups from each vertical and from campuses as well, curated by SKILLABLERS in partnership with IISc’s incubation ecosystem and national accelerators will be a game changer.',
    'Bangalore, often called the “Silicon Valley of India,” represents the ideal environment for a convergence of research, innovation, industry, and policy. With its strong base of PSUs, MNCs, elite educational institutions, and startup unicorns, Bangalore is a natural host for the inaugural regional edition of Strategic TechTrust Conclave.',
    'IISc stands as a national icon for research and technological excellence, while DRDO and ISRO’s presence ensures credibility, vision, and gravitas.'
  ],
  Images: [{ image: Startup1, order: 3 }, { image: Startup2, order: 2 }, { image: Startup3, order: 1 }, { image: Startup4, order: 4 }, { image: Startup5, order: 5 }, { image: Startup6, order: 7 }, { image: Startup7, order: 6 }]
};


// UPDATED: Enhanced 3-Day Agenda with new structure
export const agenda = {
  // heading: '3-Day Program',
  heading: 'Program Details',
  headingDescription: 'January 21, 2026 at JN Tata Auditorium, IISc Campus',
  programPhilosophy: 'The Program Structure for the Strategic TechTrust Conclave is designed to engage a wide spectrum of stakeholders – from top executives to emerging youth innovators – through a progressive thematic focus across each day.',

  content: [
    {
      day: 'Day 1',
      date: '29 October 2025',
      display: true,
      order: 1,
      theme: 'Executive Focus',
      subtitle: 'VIP Sessions & Strategic Roundtables',
      description: 'Executive Focus is dedicated to VIP sessions and strategic roundtables tailored for C-suite leaders and policymakers. The day features keynote addresses delivered by industry titans, critical policy dialogues involving government representatives, and exclusive networking opportunities aimed at fostering high-level collaboration.',
      image: Day1
    },
    {
      day: 'Day 2',
      date: '30 October 2025',
      display: true,
      order: 2,
      theme: 'Professional Development',
      subtitle: 'Technology Application & Industry Collaboration',
      description: 'Professional Development centers on the practical application of emerging technologies and industry trends. Professionals from industry and academia will engage in specialized domain tracks, participate in forums designed to encourage industry-academia collaboration, and attend skills enhancement workshops curated for immediate applicability.',
      image: Day2
    },
    {
      day: 'Day 3',
      date: '31 October 2025',
      display: true,
      order: 3,
      theme: 'Youth Engagement',
      subtitle: 'Student Innovation & Future Talent',
      description: 'Youth Engagement places the spotlight on students and emerging talent. The day includes hackathons and coding competitions to showcase technical skills, career fairs and mentorship sessions to guide career pathways, and student innovation showcases that highlight original solutions and entrepreneurial spirit.',
      image: Day3
    }
  ],

  closingStatement: 'Together, these three days offer a comprehensive platform to align leadership vision, professional capacity building, and future talent development under one strategic conclave.'
};

// UPDATED: Enhanced Venue Section with location justification
export const venue = {
  display: true,
  heading: 'Venue Information',
  headingDescription: 'Taj MG Road - Trinity Hall, Bengaluru',

  // Updated working Google Maps URL
  googleMapsUrl: 'https://maps.app.goo.gl/pCXRkmrtm2CmjXQk9',


  locationJustification: {
    heading: 'Why Bangalore & IISc?',
    content: {
      bangalore: 'Bangalore, often called the "Silicon Valley of India," represents the ideal environment for a convergence of research, innovation, industry, and policy. With its strong base of PSUs, MNCs, elite educational institutions, and startup unicorns, Bangalore is a natural host for the inaugural regional edition of Strategic TechTrust Conclave.',
      iisc: 'IISc stands as a national icon for research and technological excellence, while DRDO and ISRO\'s presence ensures credibility, vision, and gravitas.',
      ecosystem: ['PSUs & MNCs Hub', 'Elite Educational Institutions', 'Startup Unicorns', 'Research Excellence', 'Policy Convergence']
    }
  },

  left: {
    title: 'About the Venue',
    description: 'An iconic luxury hotel in Bangalore, Taj MG Road, Bengaluru is a reflection of the spirit and ethos of the city and its people.',

    items: [
      {
        title: 'Address',
        description: `Taj MG Road, 41/3 MG Road, Bengaluru - 560001, Karnataka`,
        icon: MapPin,
        iconColor: 'text-primary',
        order: 1,
        display: true
      },
      {
        title: 'Event Timings',
        description: `9:00 AM - 6:00 PM \nRegistration opens at 8:00 AM`,
        icon: Clock,
        iconColor: 'text-primary',
        order: 2,
        display: false
      },
      {
        title: 'Facilities',
        description: 'Modern auditorium, exhibition halls, networking spaces, parking facilities, and Wi-Fi connectivity',
        icon: Building,
        iconColor: 'text-primary',
        order: 3,
        display: false
      }
    ],
    image: Venu_image,
    // googleMapsUrl:'https://www.google.com/maps/place/JN+Tata+Auditorium/@13.0143,77.5673,17z/data=!3m1!4b1!4m6!3m5!1s0x0:0x0!8m2!3d13.0143!4d77.5673!16s%2Fg%2F1hc6qxqxq',
  },

  right: {
    title: 'Getting There',
    description: 'Transportation options to reach the venue',
    items: [
      {
        title: 'By Car',
        description: 'MG Road - 2 KM, Malleswaram - 8 KM, Shivaji Nagar - 3 KM',
        emoji: '🚗',
        iconColor: 'bg-primary',
        order: 1,
        display: true
      },
      {
        title: 'By Metro/Bus',
        description: 'Nearest Metro: Trinity Circle. Bus Routes: 306-F, 306-L, 306-MH, 316-T, 322-A, G-2, KBS-12HK, and MKT-12HK',
        emoji: '🚌',
        iconColor: 'bg-secondary',
        order: 2,
        display: true
      },
      {
        title: 'From Airport',
        description: 'Kempegowda International Airport (KIA) - 35 KM via  Prepaid Taxi / City Taxi / BMTC Vayu Vajra Airport Buses',
        emoji: '✈️',
        iconColor: 'bg-tech-accent',
        order: 3,
        display: true
      },
      {
        title: 'Nearby Hotels',
        description: 'Multiple accommodation options within 2-5 km radius',
        emoji: '🏨',
        iconColor: 'bg-success',
        order: 4,
        display: true
      }
    ]
  },
  // VenuImage :[{order:1,image:venueImg},{order:2,image:venueImg2},{order:3,image:venueImg3},{order:4,image:venueImg4},{order:5,image:venueImg5},{order:6,image:venueImg6}]
  VenuImage: [{ order: 1, image: venueImg }]
};

// Rest of the existing data structures remain the same...
export const focusAreas = {
  heading: 'Technology Focus Areas',
  headingDescription: 'Exploring cutting-edge technologies that will shape our future',
  content: [
    {
      icon: Cpu,
      title: 'AI/ML',
      description: 'Harnessing artificial intelligence and machine learning',
      order: 1,
      display: true
    },
    {
      icon: Shield,
      title: 'Cybersecurity',
      description: 'Protecting digital assets and critical infrastructure',
      order: 2,
      display: true
    },
    {
      icon: Zap,
      title: 'Quantum Computing',
      description: 'Pioneering the next computing frontier',
      order: 4,
      display: true
    },
    {
      icon: Bot,
      title: 'UAV / Robotics',
      description: 'Advancing aerial innovation across multiple sectors',
      order: 3,
      display: true
    }
  ]
};

export const verticals = {
  heading: 'Key Industry Verticals',
  headingDescription: 'Driving innovation across critical sectors',
  content: [
    {
      icon: Shield,
      name: 'Def-Tech',
      color: 'text-primary',
      description: 'Visualizing smart, autonomous defense for tomorrow​',
      display: true,
      order: 1
    },
    // {
    //   icon: Building,
    //   name: 'Infra-Tech',
    //   color: 'text-tech-accent',
    //   description: 'Building smart, sustainable infrastructure for tomorrow​',
    //   display: true,
    //   order: 2
    // },
    // {
    //   icon: Heart,
    //   name: 'Health-Tech',
    //   color: 'text-success',
    //   description: 'Revolutionising healthcare delivery and patient outcomes​',
    //   display: true,
    //   order: 3
    // },
    // {
    //   icon: DollarSign,
    //   name: 'BFSI-Tech',
    //   color: 'text-warning',
    //   description: 'Creating accessible financial ecosystems for all​',
    //   display: true,
    //   order: 4
    // },
    // {
    //   icon: BookOpen,
    //   name: 'Skill-Tech',
    //   color: 'text-secondary',
    //   description: 'Transforming learning experiences through technology innovation​',
    //   display: true,
    //   order: 5
    // }
  ]
};

export const audienceList = {
  heading: 'Who Should Attend?',
  headingDescription: 'Explore the diverse spectrum of participants converging at the Strategic TechTrust Conclave 2026.',
  content: [
    {
      icon: Users,
      title: 'Industry Professionals',
      description: 'Connect with peers, showcase innovation, and explore sector-specific breakthroughs.',
      display: true,
      order: 1
    },
    {
      icon: Briefcase,
      title: 'Institutions',
      description: 'Engage with research leaders and demonstrate institutional innovation in emerging tech.',
      display: true,
      order: 2
    },
    {
      icon: School,
      title: 'Youth & Students',
      description: 'Participate in workshops, competitions, and live showcases designed to inspire future tech leaders.',
      display: true,
      order: 3
    },
    {
      icon: Landmark,
      title: 'Government & PSU',
      description: 'Collaborate on policy frameworks and drive adoption of transformative technologies.',
      display: true,
      order: 4
    },
    {
      icon: ShieldCheck,
      title: 'Defence & R&D',
      description: 'Explore strategic innovations in DEFTECH and engage with experts in national security tech.',
      display: true,
      order: 5
    }
  ]
};

export const speakers = {
  heading: 'Distinguished Panelists',
  headingDescription: 'A stellar lineup of industry leaders, cybersecurity experts, and AI pioneers sharing their insights and experiences. Gain unparalleled knowledge and inspiration from the visionaries shaping the future of digital security and innovation',
  content: [
    {
      name: 'Ms. Suma Varughese',
      organization: 'DRDO',
      designation: 'Former DG – MED, CoS & CS (MCC)',
      expertise: 'Defense Technology',
      bio: '',
      linkedin: '',
      sessions: [],
      image: Suma_Varughese,
      display: true,
      order: 1
    },
    {
      name: 'Dr. K Rajalakshmi Menon',
      organization: 'DG – Aeronautical Systems, DRDO',
      designation: 'Distinguished Scientist',
      expertise: 'AI Research',
      bio: 'Dr. Menon began her career at DRDO in 1988 as a Scientist-B at CABS, then known as ASWAC, following her MSc in Computer Science from the University of Pune. She further pursued a Master\'s in Engineering and a PhD in Aerospace Engineering from the Indian Institute of Science.',
      linkedin: '',
      sessions: ['AI in Defense Applications', 'Panel: Future of AI'],
      image: K_Rajalakshmi_Menon,
      display: true,
      order: 2
    },
    {
      name: 'V K Prafulla Chandran',
      organization: 'Advisor to DG - ADA & Executive Director',
      designation: 'Outstanding Scientist',
      expertise: 'Cybersecurity',
      bio: '',
      linkedin: '',
      sessions: [],
      image: VK_Prafulla_Chandran,
      display: true,
      order: 3
    },
    {
      name: 'Padmashri Dr. Prahlada Rama Rao',
      organization: 'Defence Research & Dev. Laboratory',
      designation: 'Former Director',
      expertise: 'Quantum Computing',
      bio: '',
      linkedin: '',
      sessions: [],
      image: Prahlada_Rama_Rao,
      display: true,
      order: 4
    },
    {
      name: 'Padmashri Dr. Kota Harinarayana',
      organization: 'Light Combat Aircraft (LCA), DRDO',
      designation: 'Former Director',
      expertise: 'Quantum Computing',
      bio: '',
      linkedin: '',
      sessions: [],
      image: Kota_Harinarayana,
      display: true,
      order: 5
    },
    {
      name: 'Prof. S Sadagopan',
      organization: 'IIITB',
      designation: 'Founding Director',
      expertise: 'Quantum Computing',
      bio: '',
      linkedin: '',
      sessions: [],
      image: S_Sadagopan,
      display: true,
      order: 6
    }
  ]
};

export const sponsorTiers = {
  heading: 'Sponsorship Opportunities',
  headingDescription: 'Showcase your leadership in trusted tech by sponsoring India\'s most strategic platform for deep technology, defense, and innovation.',
  display: true,
  tiers: [
    {
      tier: 'Title Sponsor',
      price: '',
      order: 1,
      display: true,
      benefits: [
        'Prime logo placement',
        'Keynote speaking slot',
        'Exhibition booth (Premium)',
        'VIP networking access',
        'Marketing co-branding rights'
      ]
    },
    {
      tier: 'Platinum',
      price: '',
      order: 2,
      display: true,
      benefits: [
        'Logo on all materials',
        'Panel discussion slot',
        'Exhibition booth (Large)',
        'Networking dinner access',
        'Media interview opportunities'
      ]
    },
    {
      tier: 'Gold',
      price: '',
      order: 3,
      display: true,
      benefits: [
        'Logo placement',
        'Exhibition booth (Medium)',
        'Networking access',
        'Digital marketing inclusion',
        'Certificate presentation'
      ]
    },
    {
      tier: 'Silver',
      price: '',
      order: 4,
      display: true,
      benefits: [
        'Logo listing',
        'Exhibition booth (Standard)',
        'Event access',
        'Digital presence',
        'Networking opportunities'
      ]
    }
  ]
};

export const objectives = {
  heading: 'Vision & Objectives',
  headingDescription: 'The Strategic TechTrust Conclave aims to create a robust ecosystem where cutting-edge technology meets practical application across vital sectors. By bringing together diverse stakeholders, we will catalyse innovation that addresses real-world challenges whilst opening doors for the next generation of tech talent.',
  content: [
    {
      title: 'Enable Institutional Opportunities',
      icon: Briefcase,
      description: 'Connect institutions with corporate recruitment pipelines​',
      display: true,
      order: 1
    },
    {
      title: 'Engage Youth',
      icon: Users,
      description: 'Inspire the next generation of tech innovators​',
      display: true,
      order: 2
    },
    {
      title: 'Showcase Leadership',
      icon: Globe,
      description: 'Position India as a global technology powerhouse​',
      display: true,
      order: 3
    },
    {
      title: 'Foster Collaboration',
      icon: HeartHandshake,
      description: 'Create synergies between industry, academia and government​',
      display: true,
      order: 4
    },
    {
      title: 'Accelerate Innovation',
      icon: Lightbulb,
      description: 'Drive digital transformation across critical sectors',
      display: true,
      order: 5
    },
    {
      title: 'Promote Indigenous Technology',
      description: 'Showcase and support homegrown technology solutions that address national priorities.',
      icon: Shield,
      display: true,
      order: 6
    }
  ]
};

export const aboutContent = {
  heading: "About",
  // New, passive configuration for full Figma-aligned text block:
  intro: [
    {
      type: "rich",
      content: [
        "The ",
        {
          highlight: true,
          gradient: true,
          text: "Strategic TechTrust Conclave 2026 (STTC 2026)"
        },
        ", is a flagship initiative focused on connecting the dots between emerging technologies, industrial transformation, academic excellence, and national security. Hosted at the Taj MG Road, Bengluru, this conclave is distinct for aligning with India’s vision for technology-led economic and social development."
      ]
    },
    {
      type: "rich",
      content: [
        "Co-hosted by India’s most iconic institutions – ",
        {
          highlight: true,
          color: "primary",
          text: "CSI (Computer Society of India)"
        },
        ", ",
        {
          highlight: true,
          color: "primary",
          text: "DRDO (Defence Research and Development Organisation)"
        },
        ", ",
        {
          highlight: true,
          color: "primary",
          text: "ISRO (Indian Space Research Organisation)"
        },
        ", ",
        {
          highlight: true,
          color: "primary",
          text: "BrahMos Aerospace"
        },
        ", and ",
        {
          highlight: true,
          color: "primary",
          text: "CSIR-NAL"
        },
        " – the conclave will be a convergence point for thought leaders, technocrats, academicians, policymakers, youth innovators, and industrial visionaries."
      ]
    },
    {
      type: "simple",
      text:
        "SKILLABLERS (SKL), as the Curation Partner, will bring its unique AI-native platform capabilities, youth connect programs, and institutional network to ensure the conclave’s execution at scale, with purpose."
    }
  ],
  // Use one of the following:
  video: {
    src: gifvideo,
    poster: "/media/uploads/about-section-poster.jpg"
  },
  // OR (uncomment this block and comment the above for GIF)
  // gif: {
  //   src: aboutvideo,
  //   poster: ""
  // }
};

export const audienceMetrics = [
  {
    title: 'Industry Professionals',
    description: 'C-suite executives, technology leaders, and innovation directors from India\'s fastest-growing sectors.',
    value: '1000+',
    image: '/media/audience/industry.jpg',
    display: true,
    order: 1
  },
  {
    title: 'Institution Professionals',
    description: 'Academic leaders, researchers, and directors from premier educational and research institutions.',
    value: '500+',
    image: '/media/audience/institutions.jpg',
    display: true,
    order: 2
  },
  {
    title: 'Youth & HEI Students',
    description: 'Engineering, science, and management students representing India\'s next generation of tech talent.',
    value: '1000+',
    image: '/media/audience/youth.jpg',
    display: true,
    order: 3
  },
  {
    title: 'Government & PSU Officials',
    description: 'Policy makers and public sector leaders driving national technology initiatives and frameworks.',
    value: '100+',
    image: '/media/audience/psu.jpg',
    display: true,
    order: 4
  },
  {
    title: 'Defence Personnel',
    description: 'Military leaders and experts in security working on national defence solutions.',
    value: '50+',
    image: '/media/audience/defence.jpg',
    display: true,
    order: 5
  },
  {
    title: 'School Students',
    description: 'Young innovators in specialised programmes for early tech engagement and skills.',
    value: '2500+',
    image: '/media/audience/school.jpg',
    display: true,
    order: 6
  }
];

export const partners = [
  {
    title: 'Organized By',
    order: 1,
    display: true,
    entries: [
      {
        name: 'Skillablers Technologies',
        tagline: 'Leading the way in technology education and innovation events',
        logo: SKL_Logo,
        url: 'https://www.skillablers.com',
        order: 1,
        display: true
      }
    ]
  },
  {
    title: 'Co-Hosted By',
    order: 2,
    display: true,
    entries: [
      {
        name: 'DRDO',
        tagline: 'Advancing defence research and innovation',
        logo: drdo_logo,
        url: 'https://www.drdo.gov.in',
        order: 1,
        display: true
      },
      {
        name: 'CSI India',
        tagline: 'Empowering tech professionals across India',
        logo: CSI_roundLogo,
        url: 'https://www.csi-india.org',
        order: 2,
        display: true
      }
    ]
  },
  {
    title: 'Venue By',
    order: 3,
    display: true,
    entries: [
      {
        name: "JN Tata Auditorium(IISc)",
        tagline: '',
        logo: IISc_Logo,
        url: "https://iisc.ac.in/",
        display: true,
        order: 1,
      }
    ]
  }
];

export const contactInfo = {
  heading: 'Contact Us',
  description: 'Get in touch for more information about the conclave',
  contactChannels: [
    {
      type: 'General Inquiries',
      iconColor: 'bg-primary',
      value: 'techtrustconclave@skillablers.com',
      icon: Mail,
      display: true,
      order: 1
    },
    {
      type: 'Sponsorship Inquiries',
      iconColor: 'bg-secondary',
      value: 'techtrustconclave@skillablers.com',
      icon: Mail,
      display: true,
      order: 2
    },
    {
      type: 'Exhibition Inquiries',
      iconColor: 'bg-tech-accent',
      value: 'techtrustconclave@skillablers.com',
      icon: Mail,
      display: true,
      order: 3
    },
    {
      type: 'Phone Support',
      iconColor: 'bg-success',
      value: '+91 63602 28416',
      subtext: 'Mon-Fri, 9:00 AM - 6:00 PM',
      icon: Phone,
      display: true,
      order: 4
    }
  ]
};

export const exhibitorsSection = {
  heading: 'Exhibit at TechTrust 2026',
  description: 'Put your technology in front of national decision-makers, industry buyers, and policy enablers. This is your moment to lead.',
  display: true,
  left: {
    title: 'Why Exhibit?',
    display: true,
    items: [
      {
        icon: Users,
        iconColor: 'bg-primary',
        title: 'Engage High-Level Delegates',
        description: 'Gain direct access to senior government officials, R&D heads, and procurement officers.',
        order: 1,
        display: true
      },
      {
        icon: Trophy,
        iconColor: 'bg-secondary',
        title: 'National Visibility',
        description: 'Position your solutions as part of India\'s trusted tech ecosystem on a high-impact platform.',
        order: 2,
        display: true
      },
      {
        icon: Building,
        iconColor: 'bg-tech-accent',
        title: 'Lead Generation & Collaborations',
        description: 'Secure meaningful partnerships and catalyze real-world deployment of your tech.',
        order: 3,
        display: true
      }
    ]
  },
  right: {
    title: 'Booth Packages',
    description: 'Tailored spaces for every type of exhibitor',
    display: true,
    packages: [
      {
        name: 'Standard Booth (3×3m)',
        description: 'Great for startups & innovation labs',
        price: '',
        order: 1,
        display: true
      },
      {
        name: 'Large Booth (3×6m)',
        description: 'For mid-scale innovators & product companies',
        price: '',
        order: 2,
        display: true
      },
      {
        name: 'Premium Booth (6×6m)',
        description: 'Reserved for major industry or government labs',
        price: '',
        order: 3,
        display: true
      }
    ]
  }
};

export const EventMetaitems = [
  {
    label: 'January 21, 2026',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-purple-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
    ),
  },
  {
    label: 'Taj, MG Road, Bangalore',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-purple-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a2 2 0 01-2.828 0l-4.243-4.243a8 8 0 1111.314 0z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
  },
  {
    label: '500+ Delegates',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-purple-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a4 4 0 00-5-4M9 20H4v-2a4 4 0 015-4m5-4a4 4 0 100-8 4 4 0 000 8zm6 4a4 4 0 11-8 0 4 4 0 018 0z" />
      </svg>
    ),
  },
  {
    label: '5 Industry Verticals',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-purple-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 6h18M3 12h18M3 18h18" />
      </svg>
    ),
  },
  {
    label: '4 Emerging Technologies',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-purple-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
      </svg>
    ),
  },
];

// export const advisoryBoard = {
//   heading: "Visionary Patrons",
//   headingDescription: "Thought leaders guiding the strategic direction of the conclave.",
//   members: [



//       {
//       name: 'Smt. Suma Varughese​',
//       organization: 'DG – MED, CoS&CS (MCC), DRDO',
//       designation: 'Distinguished Scientist​',
//       expertise: '',
//       bio: '',
//       linkedin: '',
//       sessions: [],
//       image: Suma_Varughese,
//       display: true,
//       order: 4
//     },



//     {
//       name: 'Dr. K Rajalakshmi Menon​',
//       organization: 'DG – Aeronautical Systems, DRDO',
//       designation: 'Distinguished Scientist​',
//       expertise: '',
//       bio: 'Dr. Menon began her career at DRDO in 1988 as a Scientist-B at CABS, then known as ASWAC, following her MSc in Computer Science from the University of Pune. She further pursued a Master\'s in Engineering and a PhD in Aerospace Engineering from the Indian Institute of Science.',
//       linkedin: 'https://in.linkedin.com/in/rajalakshmi-menon-42b51912',
//       sessions: ['AI in Defense Applications', 'Panel: Future of AI'],
//       image: K_Rajalakshmi_Menon,
//       display: true,
//       order: 5
//     },
//     {
//       name: 'Shri. V K Prabhulla Chandran​',
//       organization: 'Advisor to DG - ADA & Executive Director',
//       designation: 'Outstanding Scientist',
//       expertise: '',
//       bio: '',
//       linkedin: '',
//       sessions: [],
//       image: VK_Prafulla_Chandran,
//       display: true,
//       order: 3
//     },

//     {
//       name: 'Padma Shri Dr. Prahlada Rama Rao​',
//       organization: 'Defence Research & Dev. Laboratory',
//       designation: 'Former Director',
//       expertise: '',
//       bio: '',
//       linkedin: '',
//       sessions: [],
//       image: Prahlada_Rama_Rao,
//       display: true,
//       order: 2
//     },

//     {
//       name: 'Padma Shri Dr. Kota Harinarayana​',
//       organization: 'Light Combat Aircraft (LCA), DRDO',
//       designation: 'Former Director',
//       expertise: '',
//       bio: '',
//       linkedin: '',
//       sessions: [],
//       image: Kota_Harinarayana,
//       display: true,
//       order: 1
//     },
//     {
//       name: 'Prof. S Sadagopan​',
//       organization: 'IIITB',
//       designation: 'Founding Director',
//       expertise: '',
//       bio: '',
//       linkedin: '',
//       sessions: [],
//       image: S_Sadagopan,
//       display: true,
//       order: 9
//     },

//      {
//       name: 'Dr. V. Narayanan​',
//       organization: 'Chairman, ISRO​​',
//       designation: 'Secretary, DOS​',
//       expertise: '',
//       bio: '',
//       linkedin: '',
//       sessions: [],
//       image: Narayana,
//       display: true,
//       order: 6
//     },

//      {
//       name: 'Dr. Jaiteerth R. Joshi​',
//       organization: 'DG - Brahmos, DRDO',
//       designation: '​CEO & MD of BrahMos Aerospace​',
//       expertise: '',
//       bio: '',
//       linkedin: '',
//       sessions: [],
//       image: Jitesh,
//       display: true,
//       order: 7
//     },


//      {
//       name: 'Dr. BHVS Narayana Murthy',
//       organization: 'DIAT, Pune',
//       designation: 'VC',
//       expertise: '',
//       bio: '',
//       linkedin: '',
//       sessions: [],
//       image: bhvs,
//       display: true,
//       order: 8
//     },

//     {
//         name: 'Pradeep Khanna',
//         organization: 'Global Mindset, Australia',
//         designation: 'CEO',
//         expertise: '',
//         bio: '',
//         linkedin: '',
//         sessions: [],
//         image: Pradeep_Khanna,
//         display: true,
//         order: 10
//       },

//       {
//         name: 'Dileep Kumar',
//         organization: 'PDCOR Ltd, India',
//         designation: 'CEO',
//         expertise: '',
//         bio: '',
//         linkedin: '',
//         sessions: [],
//         image: Dileep_Kumar,
//         display: true,
//         order: 11
//       },



//       {
//         name: 'Shibu Pillai',
//         organization: 'STERIS, USA',
//         designation: 'Specialist System Engineer',
//         expertise: '',
//         bio: '',
//         linkedin: '',
//         sessions: [],
//         image: Shibu_Pillai,
//         display: true,
//         order: 12
//       }
//     ]
// };

export const organizerLogos = {
  display: true,
  entries: [
    {
      role: "Organizing Partners",
      order: 1,
      display: true,
      logos: [
        {
          name: "DRDO",
          logo: drdo_logo,
          url: "https://www.drdo.gov.in/",
          display: true,
          order: 1,
        },
        {
          name: "ISRO",
          logo: ISRO_Logo,
          url: "https://www.isro.gov.in/",
          display: true,
          order: 2,
        },
        {
          name: "BrahMos Aerospace",
          logo: Brahmos_Logo,
          url: "https://www.brahmos.com/",
          display: true,
          order: 3,
        },
      ],
    },
    {
      role: "Venue Partner",
      order: 4,
      display: true,
      logos: [
        {
          name: "JN Tata Auditorium(IISc)",
          logo: IISc_Logo,
          url: "https://iisc.ac.in/",
          display: true,
          order: 1,
        },
      ],
    },
  ],
};

export const audienceBandMetrics = {
  heading: 'Audience Metrics',
  headingDescription: 'Expected Participation Across Sectors',
  metrics: [
    { label: 'Industry Professionals', count: '1000+', icon: 'Briefcase', order: 1, display: true },
    { label: 'Institution Professionals', count: '500+', icon: 'GraduationCap', order: 2, display: true },
    { label: 'Youth & HEI Students', count: '1000+', icon: 'User', order: 3, display: true },
    { label: 'Government & PSU Officials', count: '100+', icon: 'Landmark', order: 4, display: true },
    { label: 'Defence Personnel', count: '50+', icon: 'Shield', order: 5, display: true },
    { label: 'School Students', count: '2500+', icon: 'School', order: 6, display: true }
  ]
};

export const getInvolvedOptions = [
  {
    title: "Become a Partner",
    emoji: "🤝",
    description: "Collaborate with us to co-create impact in the tech ecosystem.",
    cta: "Explore Partnership",
    order: 1,
    display: true
  },
  {
    title: "Become an Exhibitor",
    emoji: "🧃",
    description: "Showcase your innovations, products or services to a high-impact audience.",
    cta: "Book a Booth",
    order: 2,
    display: true
  },
  {
    title: "Become a Speaker",
    emoji: "🗣️",
    description: "Inspire and lead conversations by sharing your expertise on stage.",
    cta: "Apply to Speak",
    order: 3,
    display: true
  },
  {
    title: "Become a Media Partner",
    emoji: "📰",
    description: "Collaborate to amplify the event's visibility and gain exclusive access.",
    cta: "Partner with Us",
    order: 4,
    display: true
  },
  {
    title: "Become a Delegate",
    emoji: "🧑‍💼",
    description: "Attend insightful sessions and engage with industry and academic leaders.",
    cta: "Register Now",
    order: 5,
    display: true,
    subtypes: [
      { label: "Students", icon: "🎓", description: "UG/PG/Research students", display: true, order: 1 },
      { label: "Aspiring Professionals", icon: "🚀", description: "Fresh graduates/Job seekers", display: true, order: 2 },
      { label: "Young Professionals", icon: "💼", description: "Working professionals (<5 years experience)", display: true, order: 3 },
      { label: "Industry Professionals", icon: "🏢", description: "Experienced professionals", display: true, order: 4 },
      { label: "Institute Faculties", icon: "👩‍🏫", description: "Faculty members", display: true, order: 5 },
      { label: "Institution", icon: "🏫", description: "Academic institutions", display: true, order: 6 },
      { label: "Industry/Corporate", icon: "🏭", description: "Corporate organizations", display: true, order: 7 }
    ]
  }
];

//commented by jithin on17-10-2026
// export const eventStats = [
//   { count: "30+", label: "Sessions", display: true, order: 1 },
//   { count: "65+", label: "Innovators", display: true, order: 2 },
//   { count: "125+", label: "Thought Leaders", display: true, order: 3 },
//   { count: "5K+", label: "Delegates", display: true, order: 4 },
//   // { count: "93", label: "Days", display: true, order: 4 },
// ];

export const eventStats = [
  // { count: "30+", label: "Sessions", display: true, order: 1 },
  // { count: "65+", label: "Innovators", display: true, order: 2 },
  // { count: "125+", label: "Thought Leaders", display: true, order: 3 },
  // { count: "5K+", label: "Delegates", display: true, order: 4 },
  // { count: "93", label: "Days", display: true, order: 4 },
];
export const Bannerpartners = [

  {
    title: 'Organized By',
    order: 1,
    display: true,
    entries: [
      {
        name: 'Skillablers Technologies',
        tagline: 'Leading the way in technology education and innovation events',
        logo: SKL_Logo,
        url: 'https://www.skillablers.com',
        order: 1,
        display: true
      }
    ]
  },
  {
    title: 'Co-Hosted By',
    order: 2,
    display: true,
    entries: [
      {
        name: 'DRDO',
        tagline: 'Advancing defence research and innovation',
        logo: drdo_logo_banner,
        url: 'https://www.drdo.gov.in',
        order: 1,
        display: true
      },
      {
        name: "BrahMos Aerospace",
        logo: Banner_BrahMos,
        tagline: 'Empowering tech professionals across India',
        // logo: CSI_roundLogo,
        // url: 'https://www.csi-india.org',
        order: 2,
        display: true
      },
      {
        name: "ISRO",
        logo: bannerisro,
        tagline: 'Empowering tech professionals across India',
        // logo: CSI_roundLogo,
        // url: 'https://www.csi-india.org',
        order: 3,
        display: true
      },
      {
        name: "CSIR-NAL",
        logo: NAL_Logo,
        tagline: 'Creating a Vision, fulfilling a Mission.',
        // logo: CSI_roundLogo,
        // url: 'https://www.csi-india.org',
        order: 4,
        display: true
      },
    ]
  },

  {
    title: 'Venue By',
    order: 3,
    display: true,
    entries: [
      {
        name: "JN Tata Auditorium(IISc)",
        tagline: '',
        logo: IISc_Logo,
        url: "https://iisc.ac.in/",
        display: true,
        order: 1,
      }
    ]
  },
  {
    title: 'Distinguished Partners',
    order: 4,
    display: true,
    entries: [
      {
        name: 'EDC',
        tagline: '',
        logo: EDC,
        url: 'https://www.edccts.com/',
        order: 1,
        display: true
      },
      {
        name: "Exotyq",
        logo: Exotyq,
        tagline: '',
        // logo: CSI_roundLogo,
        url: 'https://shop.exotyq.com/',
        order: 2,
        display: true
      },
      {
        name: "Taurus",
        logo: Taurus,
        tagline: '',
        // logo: CSI_roundLogo,
        // url: 'https://www.csi-india.org',
        order: 3,
        display: true
      },
      {
        name: 'DRDO',
        tagline: 'Advancing defence research and innovation',
        logo: drdo_logo_banner,
        url: 'https://www.drdo.gov.in',
        order: 1,
        display: true
      },
      {
        name: "BrahMos Aerospace",
        logo: Banner_BrahMos,
        tagline: 'Empowering tech professionals across India',
        // logo: CSI_roundLogo,
        // url: 'https://www.csi-india.org',
        order: 2,
        display: true
      },
      {
        name: "ISRO",
        logo: bannerisro,
        tagline: 'Empowering tech professionals across India',
        // logo: CSI_roundLogo,
        // url: 'https://www.csi-india.org',
        order: 3,
        display: true
      },
    ]
  },
];


export const ThoughtLeaders = {
  heading: "Thought Leaders",
  headingDescription: "A stellar lineup of industry leaders, cybersecurity experts, and AI pioneers sharing their insights and experiences. Gain unparalleled knowledge and inspiration from the visionaries shaping the future of digital security and innovation.",
  PanalistData: {
    Visionary_Patrons: [

      {
        name: 'Dr. Samir V. Kamat​',
        organization: 'Chairman - DRDO',
        designation: 'Secretary, Department of Defence R&D',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: DrSamirVKamat,
        display: true,
        order: 1
      },

      {
        name: 'Dr. V. Narayanan​',
        organization: 'Chairman, ISRO​​',
        designation: 'Secretary, DOS​',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: Narayana,
        display: true,
        order: 2
      },
      {
        name: 'Dr. B K Das',
        organization: 'DG - ECS, DRDO',
        designation: 'Distinguished Scientist​',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: DrBKDas,
        display: true,
        order: 3
      },

      {
        name: 'Ms. Suma Varughese​',
        organization: 'DRDO',
        designation: 'Former DG – MED, CoS & CS (MCC)​',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: Suma_Varughese,
        display: true,
        order: 5
      },

      {
        name: 'Dr. K Rajalakshmi Menon​',
        organization: 'DRDO',
        designation: 'DG – Aeronautical Systems​',
        expertise: '',
        bio: 'Dr. Menon began her career at DRDO in 1988 as a Scientist-B at CABS, then known as ASWAC, following her MSc in Computer Science from the University of Pune. She further pursued a Master\'s in Engineering and a PhD in Aerospace Engineering from the Indian Institute of Science.',
        linkedin: 'https://in.linkedin.com/in/rajalakshmi-menon-42b51912',
        sessions: ['AI in Defense Applications', 'Panel: Future of AI'],
        image: K_Rajalakshmi_Menon,
        display: true,
        order: 4
      },

      {
        name: 'Dr Abhay A Pashilkar',
        organization: 'CSIR-NAL',
        designation: 'Director',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: DrAbhayAPashilkar,
        display: true,
        order: 6
      },

      {
        name: 'Dr. Jaiteerth R. Joshi​',
        organization: 'DG - BrahMos, DRDO',
        designation: '​CEO & MD, BrahMos Aerospace​',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: Jitesh,
        display: true,
        order: 7
      },
      {
        name: 'Dr. BHVS Narayana Murthy​',
        organization: 'DIAT, Pune​',
        designation: 'Vice Chancellor',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: bhvs,
        display: true,
        order: 8
      },
      {
        name: 'Shri. V K Prabhulla Chandran​',
        organization: 'ADA',
        designation: 'Honorary Adviser to DG (ADA)',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: VK_Prafulla_Chandran,
        display: true,
        order: 9
      },
      {
        name: 'Dr. Kota Harinarayana​',
        organization: 'Light Combat Aircraft (LCA), DRDO',
        designation: 'Padma Shri Awardee & Former Director',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: Kota_Harinarayana,
        display: true,
        order: 10
      },
      {
        name: 'Dr. Prahlada Rama Rao​',
        organization: 'Distinguished Scientist DRDO',
        designation: 'Padma Shri Awardee, Former CCR&D Aero & Former Vice Chancellor - DIAT',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: Prahlada_Rama_Rao,
        display: true,
        order: 11
      },

      {
        name: 'Prof. S Sadagopan​',
        organization: 'International Institute of Information Technology Bangalore (IIIT-B)',
        designation: 'Founding Director',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: S_Sadagopan,
        display: true,
        order: 12
      },
      {
        name: 'Shri. Pradeep Khanna',
        organization: 'Global Mindset, Australia',
        designation: 'CEO',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: Pradeep_Khanna,
        display: true,
        order: 13
      },

      {
        name: 'Shri. Dileep Kumar',
        organization: 'PDCOR Ltd, India',
        designation: 'CEO',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: Dileep_Kumar,
        display: true,
        order: 14
      },



      {
        name: 'Shri. Shibu Pillai',
        organization: 'STERIS, USA',
        designation: 'Specialist System Engineer',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: Shibu_Pillai,
        display: true,
        order: 15
      },


    ],
    Distinguished_Panelists: [

      {
        name: 'Dr. Samir V. Kamat​',
        organization: 'Chairman - DRDO',
        designation: 'Secretary, Department of Defence R&D',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: DrSamirVKamat,
        display: false,
        order: 1
      },

      {
        name: 'Dr. V. Narayanan​',
        organization: 'Chairman, ISRO​​',
        designation: 'Secretary, DOS​',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: Narayana,
        display: false,
        order: 2
      },
      {
        name: 'Shri. Tuhin Sinha​',
        organization: '',
        designation: 'Author and National Spokesperson, BJP',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: Tuhin_Sinha,
        display: true,
        order: 1
      },

      {
        name: 'Shri. Shubhanshu Shukla​',
        organization: 'Indian Air Force ​​',
        designation: 'Group Captain, ISRO Astronaut​',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: Shubhanshu_Shukla,
        display: false,
        order: 2
      },
      {
        name: 'Dr. B K Das',
        organization: 'DG - ECS, DRDO',
        designation: 'Distinguished Scientist​',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: DrBKDas,
        display: true,
        order: 4
      },

      {
        name: 'Ms. Suma Varughese​',
        organization: 'DRDO',
        designation: 'Former DG – MED, CoS & CS (MCC)​',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: Suma_Varughese,
        display: true,
        order: 5
      },

      {
        name: 'Dr. K Rajalakshmi Menon​',
        organization: 'DRDO',
        designation: 'DG – Aeronautical Systems​',
        expertise: '',
        bio: 'Dr. Menon began her career at DRDO in 1988 as a Scientist-B at CABS, then known as ASWAC, following her MSc in Computer Science from the University of Pune. She further pursued a Master\'s in Engineering and a PhD in Aerospace Engineering from the Indian Institute of Science.',
        linkedin: 'https://in.linkedin.com/in/rajalakshmi-menon-42b51912',
        sessions: ['AI in Defense Applications', 'Panel: Future of AI'],
        image: K_Rajalakshmi_Menon,
        display: true,
        order: 3
      },

      {
        name: 'Dr Abhay A Pashilkar',
        organization: 'CSIR-NAL',
        designation: 'Director',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: DrAbhayAPashilkar,
        display: true,
        order: 6
      },

      {
        name: 'Dr. Jaiteerth R. Joshi​',
        organization: 'DG - BrahMos, DRDO',
        designation: '​CEO & MD, BrahMos Aerospace​',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: Jitesh,
        display: false,
        order: 7
      },
      {
        name: 'Dr. BHVS Narayana Murthy​',
        organization: 'DIAT, Pune​',
        designation: 'Vice Chancellor',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: bhvs,
        display: false,
        order: 8
      },
      {
        name: 'Shri. V K Prabhulla Chandran​',
        organization: 'ADA',
        designation: 'Honorary Adviser to DG (ADA)',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: VK_Prafulla_Chandran,
        display: true,
        order: 9
      },
      {
        name: 'Dr. Kota Harinarayana​',
        organization: 'Light Combat Aircraft (LCA), DRDO',
        designation: 'Padma Shri Awardee & Former Director',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: Kota_Harinarayana,
        display: false,
        order: 10
      },
      {
        name: 'Dr. Prahlada Rama Rao​',
        organization: 'Distinguished Scientist DRDO',
        designation: 'Padma Shri Awardee, Former CCR&D Aero & Former Vice Chancellor - DIAT',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: Prahlada_Rama_Rao,
        display: true,
        order: 11
      },
      {
        name: 'Ms. Lakshmi Ravishankar',
        organization: 'ADA',
        designation: 'OS & Scientist',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: Lakshmi_Ravishankar,
        display: true,
        order: 12
      },
      {
        name: 'Ms. Pooja Yadav',
        organization: 'DRDO',
        designation: 'SAG',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: PoojaYadav,
        display: true,
        order: 13
      },

      {
        name: 'Shri. Manickam R',
        organization: 'DRDO',
        designation: 'ADE',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: Manickam_R,
        display: false,
        order: 14
      },

      {
        name: 'Dr. Manju Nanda​',
        organization: 'CSIR-NAL',
        designation: 'Chief Scientist',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: DrManju_Nanda,
        display: true,
        order: 15
      },
      {
        name: 'Dr. Gopal Krishna Patra',
        organization: 'Paradigm Institute (CSIR-4PI)',
        designation: 'Director CSIR–Fourth',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: DrGopal_Krishna_Patra,
        display: true,
        order: 16
      },
      {
        name: 'Dr. R K Ramanathan',
        organization: 'ADA',
        designation: 'Former Project Director',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: DrRKRamanathan,
        display: true,
        order: 17
      },

      {
        name: 'Shri. Sujith S',
        designation: 'Sci/Eng-G',
        organization: 'Group Director, CITG, MSA, VSSC',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: Sujith_S,
        display: true,
        order: 18
      },
      {
        name: 'Shri. G Sathish Kumar',
        designation: 'Sci/Eng-G',
        organization: 'DPD, TLP, SDSC SHAR ',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: GSathish_Kumar,
        display: true,
        order: 19
      },
      {
        name: 'Shri. Vijay R​',
        organization: 'ARDC, HAL',
        designation: 'DGM (Design)',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: Vijay_R,
        display: true,
        order: 20
      },
      {
        name: 'Dr. J V  Satyanarayana ​',
        organization: 'DRDO RCI',
        designation: 'Scientist H',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: DrJVSatyanarayana,
        display: false,
        order: 21
      },
      {
        name: 'Shri. Jithesh Sachdeva​',
        organization: 'DRDO ADE',
        designation: 'Scientist G',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: Jithesh_Sachdeva,
        display: false,
        order: 22
      },
      {
        name: 'Shri. Suresh Sundaram​',
        organization: 'Indian Institute of Science (IISc), Bengaluru',
        designation: 'Professor, Guidance & Control, Department of Aerospace Engineering',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: Suresh_Sundaram,
        display: false,
        order: 23
      },
      {
        name: 'Shri. Baladitya Suri',
        organization: 'Indian Institute of Science (IISc), Bengaluru',
        designation: 'Associate Professor, Department of Instrumentation & Applied Physics',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: Baladitya_Suri,
        display: true,
        order: 24
      },


      {
        name: 'Prof. S Sadagopan​',
        organization: 'International Institute of Information Technology Bangalore (IIIT-B)',
        designation: 'Founding Director',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: S_Sadagopan,
        display: false,
        order: 25
      },
      {
        name: 'Shri. Pradeep Khanna',
        organization: 'Global Mindset, Australia',
        designation: 'CEO',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: Pradeep_Khanna,
        display: false,
        order: 26
      },

      {
        name: 'Shri. Dileep Kumar',
        organization: 'PDCOR Ltd, India',
        designation: 'CEO',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: Dileep_Kumar,
        display: false,
        order: 27
      },



      {
        name: 'Shri. Shibu Pillai',
        organization: 'STERIS, USA',
        designation: 'Specialist System Engineer',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: Shibu_Pillai,
        display: false,
        order: 28
      },

      {
        name: 'Dr. Sathyanarayana Srikanta',
        organization: 'Distinguished Physician, Scientist & Social Worker',
        designation: 'MD (AIIMS), [PhD], FEDM (USA), FACE (USA), Honorary FRCP (London UK)',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: DrSathyanarayanaSrikanta,
        display: false,
        order: 29
      },
      {
        name: 'Ms. Kavitha Suresh Kumar',
        organization: 'Kyndryl',
        designation: 'Principal Software Architect',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: KavithaSureshKumar,
        display: true,
        order: 30
      },
      {
        name: 'Shri. Ashwin P Chandran',
        organization: 'AWS OpenSearch, Seattle, USA',
        designation: 'Software Development Manager',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: AshwinPChandran,
        display: true,
        order: 31
      },
      {
        name: 'Ms. Navya Iyengar',
        organization: 'LNN Evara Advisors LLP',
        designation: 'Managing Partner',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: NavyaIyengar,
        display: true,
        order: 32
      },
      {
        name: 'Shri. Jayakumar J',
        organization: 'Ex STM',
        designation: 'Consultant Semiconductor',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: Jayakumar_J,
        display: true,
        order: 33
      },
      {
        name: 'Shri. Manish',
        organization: 'AMD',
        designation: 'Design Verification (DV) Professional',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: Manish_M,
        display: true,
        order: 34
      },
      {
        name: 'Shri. Peeyush Marwaha',
        organization: 'Tech Mahindra',
        designation: 'VP, Group Delivery Head & Author, Cybersecurity, Client Advisory, Strategy ',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: Peeyush_Marwaha,
        display: true,
        order: 35
      },
      {
        name: 'Dr. Venkateswaran PS',
        organization: 'CADFEM',
        designation: 'Technical Lead – Academics',
        expertise: '',
        bio: '',
        linkedin: '',
        sessions: [],
        image: DrVenkateswaran_PS,
        display: true,
        order: 36
      },

      {
        name: "Ms. R. Thogaivani",
        organization: "Flight Simulation Group ADE, DRDO",
        designation: "Scientist F",
        expertise: "",
        bio: '',
        linkedin: '',
        sessions: [],
        image: R_Thogaivani,
        display: true,
        order: 37
      },

    ],

  },
  Buttons: [

    { label: "Visionary Patrons", value: 'Visionary_Patrons', display: true, order: 2 },
    { label: "Distinguished Panelists", value: 'Distinguished_Panelists', display: true, order: 1 },
  ]

};


export const footerInfo = {
  eventSecretariat: {
    heading: 'Conclave Secretariat',
    organization: 'SKILLABLERS Technologies',
    address: [
      '',
      '',
      'Bengaluru - 560066, Karnataka, India',
    ],
    phone: '+91 80 4852 9375',
  },
  aboutSKL: {
    heading: 'SKILLABLERS (SKL)',
    mainDescription:
      'SKILLABLERS is a patented industry-enablement platform, purpose-built to bridge the gap between academia and industry. The unique platform operates as an AI-native engagement and skilling ecosystem tailored for corporates from various industries, higher education institutions (HEIs), youth, students, and community partners.',
    description:
      'SKILLABLERS, is a pioneering effort from EDC Creative Technology Solutions - a 30-years old, award-winning, creative technology solutions enabler, providing innovative solutions and services with the finest blend of both worlds – best-of-breed software technologies and rich domain focus – tailored to meet the unique and demanding needs of chosen knowledge driven verticals and domains, thereby creating measurable business impact. Log on to [www.edccts.com](https://www.edccts.com) for more information.',


  },
  contactUs: {
    heading: 'Contact Us',
    email: 'connect@techtrustconclave.com',
    email1: 'conclave2025.csi@gmail.com',
    phone: '+91  63602 28416',
  },
  followUs: {
    heading: 'Follow Us',
    description: 'Stay connected with us on social media for the latest updates',
    socialLinks: [
      { name: 'Facebook', url: 'https://www.facebook.com/people/Tech-Trust-Conclave/61578614403391/', icon: 'Facebook' },
      { name: 'X', url: 'https://x.com/sttc2026', icon: 'XIcon' },
      { name: 'Instagram', url: ' https://www.instagram.com/techtrustconclave?igsh=MTNxMGdzb2d3bWNuZA==', icon: 'Instagram' },
      { name: 'Linkedin', url: 'https://www.linkedin.com/showcase/tech-trust-conclave/', icon: 'Linkedin' },
      { name: 'WhatsApp', url: 'https://api.whatsapp.com/send/?phone=916360228416&text=hi', icon: 'WAIcon' },
      // { name: 'Youtube', url: '#', icon: 'Youtube' },
    ],
  },
  bottomNote: null,
};

// For Partnership Binding

export const sponsorEntitlements = {
  headings: [
    "Branding Privileges",
    "Title Partners",
    "Technology Focus Partners",
    "Platinum Partners",
    "Gold Partners",
    "Silver Partners",
    "SKL Masterclass Partners",
    "SKL IAQ Partners",
    "SKL Future Stars Partners",
    "Delegate Kit Branding Partners",
    "Networking Dinner Branding Partners"
  ],
  entries: [
    {
      privilege: "Solo branding along with the STTC 2026 logo",
      values: [true, false, false, false, false, false, false, false, false, false]
    },
    {
      privilege: "Promotional video / AV slot during main sessions",
      values: [true, false, false, false, false, false, false, false, false, false]
    },
    {
      privilege: "Access to Delegate Database",
      values: [true, false, false, false, false, false, false, false, false, false]
    },
    {
      privilege: "Branded Networking Dinner Table",
      values: [true, false, false, false, false, false, false, false, false, true]
    },
    {
      privilege: "Logo on Networking Dinner collateral",
      values: [true, false, false, false, false, false, false, false, false, true]
    },
    {
      privilege: "Jury / Panelist roles in competitions or evaluations",
      values: [true, false, false, false, false, true, false, true, false, false]
    },
    {
      privilege: "Logo on trophies, medals, and winner certificates",
      values: [true, false, false, false, true, false, true, true, false, false]
    },
    {
      privilege: "Logo on Masterclass certificates and materials",
      values: [true, false, false, true, true, true, true, false, false, false]
    },
    {
      privilege: "Co-branding on specific zones (IAQ, Masterclasses, Future Stars)",
      values: [true, false, false, true, true, true, true, false, false, false]
    },
    {
      privilege: "Co-branding on conclave certificates",
      values: [true, false, false, true, true, true, true, false, false, false]
    },
    {
      privilege: "1-Page Brand WriteUp in post conclave SKL IMPACT REPORT",
      values: [true, false, false, true, true, true, true, false, false, false]
    },
    {
      privilege: "Social media promotions (Tags, Stories, Features)",
      values: [true, false, true, true, false, false, true, true, false, false]
    },
    {
      privilege: "Exclusive Session / Speaker Opportunity",
      values: [true, true, true, true, true, true, true, true, false, false]
    },
    {
      privilege: "VIP Access / Priority Seating",
      values: [true, true, true, true, true, true, true, true, false, false]
    },
    {
      privilege: "On-stage Recognition & Felicitation",
      values: [true, true, true, true, true, true, true, true, false, false]
    },
    {
      privilege: "Panel Participation / Speaking Opportunity",
      values: [true, true, true, true, true, true, true, true, false, false]
    },
    {
      privilege: "Dedicated Brand Zone",
      values: [true, true, true, true, true, true, true, true, false, false]
    },
    {
      privilege: "Branded Technology Showcase Zone / Booth",
      values: [true, true, true, true, true, true, true, true, false, false]
    },
    {
      privilege: "Post Event Delegate Mail with Partner Details",
      values: [true, true, true, true, true, true, true, true, false, false]
    },
    {
      privilege: "Brand mention in post conclave SKL IMPACT REPORT",
      values: [true, true, true, true, true, true, true, true, false, false]
    },
    {
      privilege: "Branded delegate kit inserts (Flyers); Merchandise",
      values: [true, true, true, true, true, true, true, true, true, false]
    },
    {
      privilege: "Logo on all event collaterals (LED wall, website, brochures)",
      values: [true, true, true, true, true, true, true, true, false, false]
    }
  ]
};

export const partnerEntitlements = {
  headings: [
    "Branding Privileges",
    "Title Partners",
    "Technology Focus Partners",
    "Platinum Partners",
    "Gold Partners",
    "Silver Partners",
    "SKL Masterclass Partners",
    "SKL IAQ Partners",
    "SKL Future Stars Partners",
    "Delegate Kit Branding Partners",
    "Networking Dinner Branding Partners"
  ],
  entries: [
    {
      privilege: "Solo branding along with the STTC 2026 logo",
      values: [true, false, false, false, false, false, false, false, false, false]
    },
    {
      privilege: "Promotional video / AV slot during main sessions",
      values: [true, false, false, false, false, false, false, false, false, false]
    },
    {
      privilege: "Access to Delegate Database",
      values: [true, false, false, false, false, false, false, false, false, false]
    },
    {
      privilege: "Branded Networking Dinner Table",
      values: [true, false, false, false, false, false, false, false, false, true]
    },
    {
      privilege: "Logo on Networking Dinner collateral",
      values: [true, false, false, false, false, false, false, false, false, true]
    },
    {
      privilege: "Jury / Panelist roles in competitions or evaluations",
      values: [true, false, false, false, false, true, false, true, false, false]
    },
    {
      privilege: "Logo on trophies, medals, and winner certificates",
      values: [true, false, false, false, true, false, true, true, false, false]
    },
    {
      privilege: "Logo on Masterclass certificates and materials",
      values: [true, false, false, true, true, true, true, false, false, false]
    },
    {
      privilege: "Co-branding on specific zones (IAQ, Masterclasses, Future Stars)",
      values: [true, false, false, true, true, true, true, false, false, false]
    },
    {
      privilege: "Co-branding on conclave certificates",
      values: [true, false, false, true, true, true, true, false, false, false]
    },
    {
      privilege: "1-Page Brand WriteUp in post conclave SKL IMPACT REPORT",
      values: [true, false, false, true, true, true, true, false, false, false]
    },
    {
      privilege: "Social media promotions (Tags, Stories, Features)",
      values: [true, false, true, true, false, false, true, true, false, false]
    },
    {
      privilege: "Exclusive Session / Speaker Opportunity",
      values: [true, true, true, true, true, true, true, true, false, false]
    },
    {
      privilege: "VIP Access / Priority Seating",
      values: [true, true, true, true, true, true, true, true, false, false]
    },
    {
      privilege: "On-stage Recognition & Felicitation",
      values: [true, true, true, true, true, true, true, true, false, false]
    },
    {
      privilege: "Panel Participation / Speaking Opportunity",
      values: [true, true, true, true, true, true, true, true, false, false]
    },
    {
      privilege: "Dedicated Brand Zone",
      values: [true, true, true, true, true, true, true, true, false, false]
    },
    {
      privilege: "Branded Technology Showcase Zone / Booth",
      values: [true, true, true, true, true, true, true, true, false, false]
    },
    {
      privilege: "Post Event Delegate Mail with Partner Details",
      values: [true, true, true, true, true, true, true, true, false, false]
    },
    {
      privilege: "Brand mention in post conclave SKL IMPACT REPORT",
      values: [true, true, true, true, true, true, true, true, false, false]
    },
    {
      privilege: "Branded delegate kit inserts (Flyers); Merchandise",
      values: [true, true, true, true, true, true, true, true, true, false]
    },
    {
      privilege: "Logo on all event collaterals (LED wall, website, brochures)",
      values: [true, true, true, true, true, true, true, true, false, false]
    }
  ]
};

export const Partnercatagory = [
  { label: "Title Partners", display: false, order: 1 },
  { label: "Technology Focus Partners", display: false, order: 2 },
  { label: "Gold Partners", display: false, order: 3 },
  { label: "Silver Partners", display: true, order: 4 },
  { label: "SKL Masterclass Partners", display: false, order: 5 },
  { label: "SKL IAQ Partners", display: false, order: 6 },
  { label: "SKL Future Stars Partners", display: false, order: 7 },
  { label: "Delegate Kit Branding Partners", display: false, order: 8 },
  { label: "Networking Dinner Branding Partners", display: false, order: 9 },
  { label: "Knowledge Partners", display: true, order: 10 },

]

export const sponsors = [

  //Silver Partners
  {
    // name: "HAL",
    name: "",
    category: "Silver Partners",
    display: true,
    order: 1,
    type: "Industry",
    description:
      "",
    logo: Partner_HAL_Logo,
    url: "https://hal-india.co.in/"
  },
  {
    // name: "BEL",
    name: "",
    category: "Silver Partners",
    display: true,
    order: 2,
    type: "Industry",
    description:
      "",
    logo: Partner_BEL_Logo,
    url: "https://bel-india.in/"
  },

  // {
  //   // name: "BrahMos Aerospace Pvt. Ltd",
  //   name: "",
  //   category: "Silver Partners",
  //   display: true,
  //   order: 1,
  //   type: "Industry",
  //   description:
  //     "",
  //   logo: Brahmos_Logo,
  //   url: "https://www.brahmos.com/"
  // },
  {
    // name: "Innefu",
    name: "",
    category: "Silver Partners",
    display: true,
    order: 3,
    type: "Industry",
    description:
      "",
    logo: Partner_Innefu_logo,
    url: "https://innefu.com/"
  },
  {
    // name: "CADFEM",
    name: "",
    category: "Silver Partners",
    display: true,
    order: 4,
    type: "Industry",
    description:
      "",
    logo: Partner_CADFEM_Logo,
    url: ""
  },
  {
    // name: "Vertotech Aerospace Limited",
    name: "",
    category: "Silver Partners",
    display: true,
    order: 5,
    type: "Industry",
    description:
      "",
    logo: Partner_Vertotech_Logo,
    url: "https://vertotechaerospace.com/"
  },

  {
    // name: "Alliance University",
    name: "",
    category: "Silver Partners",
    display: true,
    order: 6,
    type: "Industry",
    description:
      "",
    logo: Partner_alliance_Logo,
    url: "https://innefu.com/"
  },
  {
    // name: "Gopalan Aerospace",
    name: "",
    category: "Silver Partners",
    display: true,
    order: 7,
    type: "Industry",
    description:
      "",
    logo: Partner_AEROSPACE_Logo,
    url: "https://www.gopalanaerospace.com/"
  },
  {
    // name: "IDFC",
    name: "",
    category: "Silver Partners",
    display: true,
    order: 8,
    type: "Industry",
    description:
      "",
    logo: Partner_IDFC_Logo,
    url: "https://innefu.com/"
  },

  // Knowledge Partners
  {
    // name: "LNN Evara Advisors LLP",
    name: "",
    category: "Knowledge Partners",
    display: true,
    order: 9,
    type: "Institution",
    description:
      "",
    logo: Partner_LNN_logo,
    url: "https://evaraadvisors.com/"
  },


];

export const GetInvolved = {
  description: 'Engage with cutting-edge sessions, explore emerging tech zones, network with national and global thought leaders, and contribute to sector-specific dialogues that shape India’s strategic tech future. Whether you\'re looking to collaborate, learn, hire, innovate, or invest - this is your platform to connect, contribute, and create impact.',
  Buttons: [
    { label: "Partner", value: 'Become_a_Partner', display: true, order: 1 },
    { label: "Delegates", value: 'Delegates', display: true, order: 2 }
  ],
  // Become_a_Partner:{
  //   Tittle : [{label: "Title Partners", value:'Title Partners', display: true, order: 1},
  //     {label: "Technology Focus Partners", value:'Technology Focus Partners', display: true, order: 2},
  //     {label: "Platinum Partners", value:'Platinum Partners', display: true, order: 3},
  //     {label: "Gold Partners", value:'Gold Partners', display: true, order: 4},
  //     {label: "Silver Partners", value:'Silver Partners', display: true, order: 5},
  //     {label: "SKL Masterclass Partners", value:'SKL Masterclass Partners', display: true, order: 6},
  //     {label: "SKL IAQ Partners", value:'SKL IAQ Partners', display: true, order: 7},
  //     {label: "SKL Future Stars Partners", value:'SKL Future Stars Partners', display: true, order: 8},
  //     {label: "Delegate Kit Branding Partners", value:'Delegate Kit Branding Partners', display: true, order: 9},
  //     {label: "Networking Dinner Branding Partners", value:'Networking Dinner Branding Partners', display: true, order: 10},
  //   ],
  //   Details : {
  //     'Title Partners':[{ privilege: "Solo branding along with the STTC 2026 logo", order: 1 },
  //                         { privilege: "Promotional video / AV slot during main sessions", order: 2 },
  //                         { privilege: "Access to Delegate Database", order: 3 },
  //                         { privilege: "Branded Networking Dinner Table", order: 4 },
  //                         { privilege: "Logo on Networking Dinner collateral", order: 5 },
  //                         { privilege: "Jury / Panelist roles in competitions or evaluations", order: 6 },
  //                         { privilege: "Logo on trophies, medals, and winner certificates", order: 7 },
  //                         { privilege: "Logo on Masterclass certificates and materials", order: 8 },
  //                         { privilege: "Co-branding on specific zones (IAQ, Masterclasses, Future Stars)", order: 9 },
  //                         { privilege: "Co-branding on conclave certificates", order: 10 },
  //                         { privilege: "1-Page Brand WriteUp in post conclave SKL IMPACT REPORT", order: 11 },
  //                         { privilege: "Social media promotions (Tags, Stories, Features)", order: 12 },
  //                         { privilege: "Exclusive Session / Speaker Opportunity", order: 13 },
  //                         { privilege: "VIP Access / Priority Seating", order: 14 },
  //                         { privilege: "On-stage Recognition & Felicitation", order: 15 },
  //                         { privilege: "Panel Participation / Speaking Opportunity", order: 16 },
  //                         { privilege: "Dedicated Brand Zone", order: 17 },
  //                         { privilege: "Branded Technology Showcase Zone / Booth", order: 18 },
  //                         { privilege: "Post Event Delegate Mail with Partner Details", order: 19 },
  //                         { privilege: "Brand mention in post conclave SKL IMPACT REPORT", order: 20 },
  //                         { privilege: "Branded delegate kit inserts (Flyers); Merchandise", order: 21 },
  //                         { privilege: "Logo on all event collaterals (LED wall, website, brochures)", order: 22 }]
  //       ,
  //       'Technology Focus Partners':[
  //                         { privilege: "Exclusive Session / Speaker Opportunity", order: 1 },
  //                         { privilege: "VIP Access / Priority Seating", order: 2 },
  //                         { privilege: "On-stage Recognition & Felicitation", order: 3 },
  //                         { privilege: "Panel Participation / Speaking Opportunity", order: 4 },
  //                         { privilege: "Dedicated Brand Zone", order: 5 },
  //                         { privilege: "Branded Technology Showcase Zone / Booth", order: 6 },
  //                         { privilege: "Post Event Delegate Mail with Partner Details", order: 7 },
  //                         { privilege: "Brand mention in post conclave SKL IMPACT REPORT", order: 8 },
  //                         { privilege: "Branded delegate kit inserts (Flyers); Merchandise", order: 9 },
  //                         { privilege: "Logo on all event collaterals (LED wall, website, brochures)", order: 10 }]
  //       ,
  //       'Platinum Partners':[
  //                         { privilege: "Social media promotions (Tags, Stories, Features)", order: 1 },
  //                         { privilege: "Exclusive Session / Speaker Opportunity", order: 2},
  //                         { privilege: "VIP Access / Priority Seating", order: 3 },
  //                         { privilege: "On-stage Recognition & Felicitation", order: 4 },
  //                         { privilege: "Panel Participation / Speaking Opportunity", order: 5 },
  //                         { privilege: "Dedicated Brand Zone", order: 6 },
  //                         { privilege: "Branded Technology Showcase Zone / Booth", order: 7 },
  //                         { privilege: "Post Event Delegate Mail with Partner Details", order: 8 },
  //                         { privilege: "Brand mention in post conclave SKL IMPACT REPORT", order: 9 },
  //                         { privilege: "Branded delegate kit inserts (Flyers); Merchandise", order: 10 },
  //                         { privilege: "Logo on all event collaterals (LED wall, website, brochures)", order: 11 }]
  //       ,'Gold Partners':[
  //                         { privilege: "Logo on Masterclass certificates and materials", order: 1 },
  //                         { privilege: "Co-branding on specific zones (IAQ, Masterclasses, Future Stars)", order: 2 },
  //                         { privilege: "Co-branding on conclave certificates", order: 3 },
  //                         { privilege: "1-Page Brand WriteUp in post conclave SKL IMPACT REPORT", order: 4 },
  //                         { privilege: "Social media promotions (Tags, Stories, Features)", order: 5 },
  //                         { privilege: "Exclusive Session / Speaker Opportunity", order: 6 },
  //                         { privilege: "VIP Access / Priority Seating", order: 7 },
  //                         { privilege: "On-stage Recognition & Felicitation", order: 8 },
  //                         { privilege: "Panel Participation / Speaking Opportunity", order: 9 },
  //                         { privilege: "Dedicated Brand Zone", order: 10 },
  //                         { privilege: "Branded Technology Showcase Zone / Booth", order: 11 },
  //                         { privilege: "Post Event Delegate Mail with Partner Details", order: 12 },
  //                         { privilege: "Brand mention in post conclave SKL IMPACT REPORT", order: 13 },
  //                         { privilege: "Branded delegate kit inserts (Flyers); Merchandise", order: 14 },
  //                         { privilege: "Logo on all event collaterals (LED wall, website, brochures)", order: 15 }]
  //       ,
  //       'Silver Partners':[
  //                        { privilege: "Logo on trophies, medals, and winner certificates", order: 1 },
  //                         { privilege: "Logo on Masterclass certificates and materials", order: 2 },
  //                         { privilege: "Co-branding on specific zones (IAQ, Masterclasses, Future Stars)", order: 3 },
  //                         { privilege: "Co-branding on conclave certificates", order: 4 },
  //                         { privilege: "1-Page Brand WriteUp in post conclave SKL IMPACT REPORT", order: 5 },
  //                         { privilege: "Exclusive Session / Speaker Opportunity", order: 6 },
  //                         { privilege: "VIP Access / Priority Seating", order: 7 },
  //                         { privilege: "On-stage Recognition & Felicitation", order: 8 },
  //                         { privilege: "Panel Participation / Speaking Opportunity", order: 9 },
  //                         { privilege: "Dedicated Brand Zone", order: 10 },
  //                         { privilege: "Branded Technology Showcase Zone / Booth", order: 11 },
  //                         { privilege: "Post Event Delegate Mail with Partner Details", order: 12 },
  //                         { privilege: "Brand mention in post conclave SKL IMPACT REPORT", order: 13 },
  //                         { privilege: "Branded delegate kit inserts (Flyers); Merchandise", order: 14 },
  //                         { privilege: "Logo on all event collaterals (LED wall, website, brochures)", order: 15 }]
  //       ,
  //       'SKL Masterclass Partners':[
  //                         { privilege: "Jury / Panelist roles in competitions or evaluations", order: 1 },
  //                         { privilege: "Logo on Masterclass certificates and materials", order: 2 },
  //                         { privilege: "Co-branding on specific zones (IAQ, Masterclasses, Future Stars)", order: 3 },
  //                         { privilege: "Co-branding on conclave certificates", order: 4 },
  //                         { privilege: "1-Page Brand WriteUp in post conclave SKL IMPACT REPORT", order: 5 },
  //                         { privilege: "Exclusive Session / Speaker Opportunity", order: 6 },
  //                         { privilege: "VIP Access / Priority Seating", order: 7 },
  //                         { privilege: "On-stage Recognition & Felicitation", order: 8 },
  //                         { privilege: "Panel Participation / Speaking Opportunity", order: 9 },
  //                         { privilege: "Dedicated Brand Zone", order: 10 },
  //                         { privilege: "Branded Technology Showcase Zone / Booth", order: 11 },
  //                         { privilege: "Post Event Delegate Mail with Partner Details", order: 12 },
  //                         { privilege: "Brand mention in post conclave SKL IMPACT REPORT", order: 13 },
  //                         { privilege: "Branded delegate kit inserts (Flyers); Merchandise", order: 14 },
  //                         { privilege: "Logo on all event collaterals (LED wall, website, brochures)", order: 15 }]
  //       ,
  //       'SKL IAQ Partners':[
  //                         { privilege: "Logo on trophies, medals, and winner certificates", order: 1 },
  //                         { privilege: "Logo on Masterclass certificates and materials", order: 2 },
  //                         { privilege: "Co-branding on specific zones (IAQ, Masterclasses, Future Stars)", order: 3 },
  //                         { privilege: "Co-branding on conclave certificates", order: 4 },
  //                         { privilege: "1-Page Brand WriteUp in post conclave SKL IMPACT REPORT", order: 5 },
  //                         { privilege: "Social media promotions (Tags, Stories, Features)", order: 6 },
  //                         { privilege: "Exclusive Session / Speaker Opportunity", order: 7 },
  //                         { privilege: "VIP Access / Priority Seating", order: 8 },
  //                         { privilege: "On-stage Recognition & Felicitation", order: 9 },
  //                         { privilege: "Panel Participation / Speaking Opportunity", order: 10 },
  //                         { privilege: "Dedicated Brand Zone", order: 11 },
  //                         { privilege: "Branded Technology Showcase Zone / Booth", order: 12 },
  //                         { privilege: "Post Event Delegate Mail with Partner Details", order: 13 },
  //                         { privilege: "Brand mention in post conclave SKL IMPACT REPORT", order: 14 },
  //                         { privilege: "Branded delegate kit inserts (Flyers); Merchandise", order: 15 },
  //                         { privilege: "Logo on all event collaterals (LED wall, website, brochures)", order: 16 }]
  //       ,
  //       'SKL Future Stars Partners':[
  //                         { privilege: "Jury / Panelist roles in competitions or evaluations", order: 1 },
  //                         { privilege: "Logo on trophies, medals, and winner certificates", order: 2 },
  //                         { privilege: "Social media promotions (Tags, Stories, Features)", order: 3 },
  //                         { privilege: "Exclusive Session / Speaker Opportunity", order: 4 },
  //                         { privilege: "VIP Access / Priority Seating", order: 5 },
  //                         { privilege: "On-stage Recognition & Felicitation", order: 6 },
  //                         { privilege: "Panel Participation / Speaking Opportunity", order: 7 },
  //                         { privilege: "Dedicated Brand Zone", order: 8 },
  //                         { privilege: "Branded Technology Showcase Zone / Booth", order: 9 },
  //                         { privilege: "Post Event Delegate Mail with Partner Details", order: 10 },
  //                         { privilege: "Brand mention in post conclave SKL IMPACT REPORT", order: 11 },
  //                         { privilege: "Branded delegate kit inserts (Flyers); Merchandise", order: 12 },
  //                         { privilege: "Logo on all event collaterals (LED wall, website, brochures)", order: 13 }]
  //       ,
  //       'Delegate Kit Branding Partners':[
  //                         { privilege: "Branded delegate kit inserts (Flyers); Merchandise", order: 1 },
  //                         ]
  //       ,
  //       'Networking Dinner Branding Partners':[
  //                         { privilege: "Branded Networking Dinner Table", order: 1 },
  //                         { privilege: "Logo on Networking Dinner collateral", order: 2 },
  //                         ]

  //     }
  // },
  // Delegates:{}
}

export const partnerEntitlementsTransposed = {
  partnerTypes: [
    "Title Partners",
    // "Technology Focus Partners",
    "Platinum Partners",
    "Gold Partners",
    "Silver Partners",
    // "SKL Masterclass Partners",
    // "SKL IAQ Partners",
    // "SKL Future Stars Partners",
    // "Delegate Kit Branding Partners",
    // "Networking Dinner Branding Partners"

  ],
  entries: [
    {
      type: "Title Partners",
      delegatePasses: 10,
      Tier: 1,
      privileges: [
        "Solo branding along with the STTC 2026 logo",
        "Promotional video / AV slot during main sessions",
        "Access to Delegate Database",
        // "Branded Networking Dinner Table",
        // "Logo on Networking Dinner collateral",
        // "Jury / Panelist roles in competitions or evaluations",
        // "Logo on trophies, medals, and winner certificates",
        // "Logo on Masterclass certificates and materials",
        //"Co-branding on specific zones (IAQ, Masterclasses, Future Stars)",
        //"Co-branding on conclave certificates",
        // "1-Page Brand WriteUp in post conclave SKL IMPACT REPORT",
        "Social media promotions (Tags, Stories, Features)",
        "Exclusive Session / Speaker Opportunity",
        "VIP Access / Priority Seating",
        // "On-stage Recognition & Felicitation",
        "Panel Participation / Speaking Opportunity",
        // "Dedicated Brand Zone",
        "Branded Technology Showcase Zone / Booth",
        // "Post Event Delegate Mail with Partner Details",
        //"Brand mention in post conclave SKL IMPACT REPORT",
        "Branded delegate kit inserts (Flyers); Merchandise",
        "Logo on all event collaterals (LED wall, website, brochures)"
      ]
    },
    // {
    //   type: "Technology Focus Partners",
    //    delegatePasses: 8,
    //   Tier: 2,
    //   privileges: [
    //     // values where true at index 1 across original entries
    //     "Promotional video / AV slot during main sessions",
    //     "Access to Delegate Database",
    //     "Branded Networking Dinner Table",
    //     "Logo on Networking Dinner collateral",
    //     "Jury / Panelist roles in competitions or evaluations",
    //     "Logo on trophies, medals, and winner certificates",
    //     "Logo on Masterclass certificates and materials",
    //     "Co-branding on specific zones (IAQ, Masterclasses, Future Stars)",
    //     "Co-branding on conclave certificates",
    //     "1-Page Brand WriteUp in post conclave SKL IMPACT REPORT",
    //     "Social media promotions (Tags, Stories, Features)",
    //     "Exclusive Session / Speaker Opportunity",
    //     "VIP Access / Priority Seating",
    //     "On-stage Recognition & Felicitation",
    //     "Panel Participation / Speaking Opportunity",
    //     "Dedicated Brand Zone",
    //     "Branded Technology Showcase Zone / Booth",
    //     "Post Event Delegate Mail with Partner Details",
    //     "Brand mention in post conclave SKL IMPACT REPORT",
    //     "Branded delegate kit inserts (Flyers); Merchandise",
    //     "Logo on all event collaterals (LED wall, website, brochures)"
    //   ]
    // },
    {
      type: "Platinum Partners",
      delegatePasses: 8,
      Tier: 3,
      privileges: [
        // "Promotional video / AV slot during main sessions",
        "Access to Delegate Database",
        //"Branded Networking Dinner Table",
        // "Logo on Networking Dinner collateral",
        //"Jury / Panelist roles in competitions or evaluations",
        // "Logo on trophies, medals, and winner certificates",
        //"Logo on Masterclass certificates and materials",
        // "Co-branding on specific zones (IAQ, Masterclasses, Future Stars)",
        // "Co-branding on conclave certificates",
        //"1-Page Brand WriteUp in post conclave SKL IMPACT REPORT",
        "Social media promotions (Tags, Stories, Features)",
        "Exclusive Session / Speaker Opportunity",
        "VIP Access / Priority Seating",
        // "On-stage Recognition & Felicitation",
        "Panel Participation / Speaking Opportunity",
        //"Dedicated Brand Zone",
        "Branded Technology Showcase Zone / Booth",
        // "Post Event Delegate Mail with Partner Details",
        // "Brand mention in post conclave SKL IMPACT REPORT",
        "Branded delegate kit inserts (Flyers); Merchandise",
        "Logo on all event collaterals (LED wall, website, brochures)"
      ]
    },
    {
      type: "Gold Partners",
      delegatePasses: 5,
      Tier: 4,
      privileges: [
        "Social media promotions (Tags, Stories, Features)",
        "Exclusive Session / Speaker Opportunity",
        "VIP Access / Priority Seating",
        //"On-stage Recognition & Felicitation",
        "Panel Participation / Speaking Opportunity",
        // "Dedicated Brand Zone",
        "Branded Technology Showcase Zone / Booth",
        // "Post Event Delegate Mail with Partner Details",
        //"Brand mention in post conclave SKL IMPACT REPORT",
        "Branded delegate kit inserts (Flyers); Merchandise",
        "Logo on all event collaterals (LED wall, website, brochures)"
      ]
    },
    {
      type: "Silver Partners",
      delegatePasses: 2,
      Tier: 5,
      privileges: [
        "Branded Technology Showcase Zone / Booth",
        // "Post Event Delegate Mail with Partner Details",
        // "Brand mention in post conclave SKL IMPACT REPORT",
        "Branded delegate kit inserts (Flyers); Merchandise",
        "Logo on all event collaterals (LED wall, website, brochures)"
      ]
    },
    // {
    //   type: "SKL Masterclass Partners",
    //    delegatePasses: 2,
    //   Tier: 6,
    //   privileges: [
    //     "Logo on Masterclass certificates and materials",
    //     "Co-branding on specific zones (IAQ, Masterclasses, Future Stars)",
    //     "Co-branding on conclave certificates",
    //     "1-Page Brand WriteUp in post conclave SKL IMPACT REPORT",
    //     "Social media promotions (Tags, Stories, Features)",
    //     "Post Event Delegate Mail with Partner Details",
    //     "Brand mention in post conclave SKL IMPACT REPORT",
    //     "Branded delegate kit inserts (Flyers); Merchandise",
    //     "Logo on all event collaterals (LED wall, website, brochures)"
    //   ]
    // },
    // {
    //   type: "SKL IAQ Partners",
    //    delegatePasses: 2,
    //   Tier: 7,
    //   privileges: [
    //     "Logo on trophies, medals, and winner certificates",
    //     "Co-branding on specific zones (IAQ, Masterclasses, Future Stars)",
    //     "Co-branding on conclave certificates",
    //     "1-Page Brand WriteUp in post conclave SKL IMPACT REPORT",
    //     "Social media promotions (Tags, Stories, Features)",
    //     "Post Event Delegate Mail with Partner Details",
    //     "Brand mention in post conclave SKL IMPACT REPORT",
    //     "Branded delegate kit inserts (Flyers); Merchandise",
    //     "Logo on all event collaterals (LED wall, website, brochures)"
    //   ]
    // },
    // {
    //   type: "SKL Future Stars Partners",
    //    delegatePasses: 2,
    //   Tier: 8,
    //   privileges: [
    //     "Jury / Panelist roles in competitions or evaluations",
    //     "Logo on trophies, medals, and winner certificates",
    //     "Co-branding on specific zones (IAQ, Masterclasses, Future Stars)",
    //     "Co-branding on conclave certificates",
    //     "1-Page Brand WriteUp in post conclave SKL IMPACT REPORT",
    //     "Social media promotions (Tags, Stories, Features)",
    //     "Post Event Delegate Mail with Partner Details",
    //     "Brand mention in post conclave SKL IMPACT REPORT",
    //     "Branded delegate kit inserts (Flyers); Merchandise",
    //     "Logo on all event collaterals (LED wall, website, brochures)"
    //   ]
    // },
    // {
    //   type: "Delegate Kit Branding Partners",
    //    delegatePasses: 2,
    //   Tier: 9,
    //   privileges: [
    //     "Post Event Delegate Mail with Partner Details",
    //     "Brand mention in post conclave SKL IMPACT REPORT",
    //     "Branded delegate kit inserts (Flyers); Merchandise",
    //     "Logo on all event collaterals (LED wall, website, brochures)"
    //   ]
    // },
    // {
    //   type: "Networking Dinner Branding Partners",
    //    delegatePasses: 2,
    //   Tier: 10,
    //   privileges: [
    //     "Branded Networking Dinner Table",
    //     "Logo on Networking Dinner collateral",
    //     "Post Event Delegate Mail with Partner Details",
    //     "Brand mention in post conclave SKL IMPACT REPORT",
    //     "Branded delegate kit inserts (Flyers); Merchandise",
    //     "Logo on all event collaterals (LED wall, website, brochures)"
    //   ]
    // }
  ]
};

// ------------- Delegate Types & their Privileges ---------------------//

export const delegateEntitlementsTransposed = {
  delegateTypes: [
    "VIP Pass Delegates",
    "Defence Personnel Delegate",
    "Industry Professional Delegate",
    "Institution Professional Delegate",
    "HEI Student Delegate",
    "Youth Delegate",
    "School Students Delegate",
  ],
  entries: [
    {
      type: "VIP Pass Delegates",
      Tier: 1,
      privileges: [
        "Access to All 3 Days",
        "Inaugural Session",
        "Networking Dinner",
        "Delegate Kit",
        "Keynote Session",
        "Fireside Chats",
        "Panel Discussions",
        "MasterClasses",
        "Tech Talks",
        "Innovation Showcases",
        "Spotlight Sessions",
        "Business Networking Lounge Access",
        "B2B Access",
        "B2I Access",
        "Startup & Industry Matchmaking Zone Access",
      ],
    },
    {
      type: "Defence Personnel Delegate",
      Tier: 2,
      privileges: [
        "VIP Access to Defence-Tech and Dual-Use Innovation Tracks",
        "Reserved Seating in Security, Aerospace & AI Panels",
        "Access to Closed-Door Defence Roundtables (on invitation)",
        "Opportunity to Showcase Tech Innovations in the Defence Innovation Hall",
        "Delegate Kit",
      ],
    },
    {
      type: "Industry Professional Delegate",
      Tier: 3,
      privileges: [
        "Delegate Kit",
        "Leadership Keynotes",
        "Fireside Chats",
        "Strategic Panels Access",
        "Access to B2B Connects and CXO Roundtables (on invitation)",
        "Innovation Showcases",
        "Business Networking Lounge Access",
        "Early Access to Partner Pitch Decks & Investment Opportunities",
        "Paid Access to SKILLABLERS Masterclasses",
      ],
    },
    {
      type: "Institution Professional Delegate",
      Tier: 4,
      privileges: [
        "B2I Access",
        "Delegate Kit",
        "Paid Access to Academic Roundtables",
        "Paid Access to SKILLABLERS Masterclasses",
        "Participation in the STTC Skill Connect Tracks",
        "Eligibility to Nominate Students for Future Stars Showcase",
        "Institution–Industry Networking Session Access",
      ],
    },
    {
      type: "HEI Student Delegate",
      Tier: 5,
      privileges: [
        "Delegate Kit",
        "Access to Student Innovation Showcases",
        "Participation in Skillablers Career Labs & Resume Clinics",
        "Certificate of Participation & Eligibility for Skillablers Industry Awareness Quiz (SKL IAQ) and Hack Challenges",
        "Access to AI/Robotics/UAV Demo Sessions (on invitation)",
        "Access to Curated Internship & Mentorship Connects",
      ],
    },
    {
      type: "Youth Delegate",
      Tier: 6,
      privileges: [
        "Access to Entrepreneurship Panels & Startup Demo Zones",
        "Eligibility for Youth Challenge & Idea Pitch Battles",
        "Participation in Skillablers Career Bootcamps",
        "Single View Profile (SVP) listing in Youth Talent Registry",
        "Access to Delegate Lounge & Networking Corners",
        "Delegate Kit",
      ],
    },
    {
      type: "School Students Delegate",
      Tier: 7,
      privileges: [
        "Innovation Showcases",
        "Snack Box",
        "1-Hour Orientation Session",
      ],
    },
  ],
};

export const delegateTypes = [
  //   {
  //     type: 'VIP Delegates',
  //     registration:'Individual',
  //     groupCategory:'VIP Delegates (Group)',
  //     features: [
  //       {
  //         title: 'Categories',
  //         points: [
  //           'Government / Defence / PSU\'s personnel',
  //           'Industry Professionals',
  //           'Institution Professionals (Faculty)',
  //         ]
  //       },
  //       {
  //         title: 'Full Access to the Conclave',
  //         points: [
  //           'Entry to all keynote sessions, fireside chats, panel discussions, and masterclasses across all 3 days.',
  //           'Priority access to TechTalks, Innovation Showcases, and Spotlight Sessions by national and international thought leaders.',
  //         ]
  //       },
  //       {
  //         title: 'Knowledge & Learning',
  //         points: [
  //           'Complimentary participation in curated SKILLABLERS Masterclasses, featuring industry-led, career-focused content.',
  //           'Eligibility for STTC Certification of Participation – co-issued by organizing partners including CSI, DRDO, ISRO, and BrahMos.'
  //         ]
  //       },
  //       {
  //         title: 'Networking & Business Access',
  //         points: [
  //           'Entry to the Business Networking Lounge with opportunities to connect with C-level executives, government leaders, and academic visionaries.',
  //           'Option to pre-book B2B & B2I (Business to Institution) meetings via the conclave app.',
  //           'Access to Startup & Industry Matchmaking Zone for curated engagement with startups, CoEs, and innovation hubs.',
  //         ]
  //       },
  //       {
  //         title: 'Interactive & Immersive Zones',
  //         points: [
  //           'Guided walkthroughs of the TechTrust Experience Pavilion, showcasing live demos, immersive storytelling, and futuristic tech.',
  //           'Access to Phygital Knowledge Walls and real-time engagement zones powered by AI.'
  //         ]
  //       },
  //       {
  //         title: 'Delegate Kit & Privileges',
  //         points: [
  //           'Official STTC 2026 Delegate Kit including a smart badge, tech-enabled lanyard, souvenirs, and conclave handbook.',
  //           'Priority seating for select events (subject to availability).',
  //           'Exclusive digital resources post-event: session recordings, speaker decks, and curated industry insights.'
  //         ]
  //       },
  //       {
  //         title: 'Comfort & Hospitality',
  //         points: [
  //           'Complimentary access to refreshment zones and curated delegate-only networking dinners.',
  //           'Special offers from STTC hospitality partners for accommodation and transport.'
  //         ]
  //       }
  //     ],
  //     attend:'ACCESS ON ALL 3 DAYS',
  //     pricingTiers: [
  //       {
  //         label: "Early Bird",
  //         validTill: "2026-10-05",
  //         price: 7500,
  //         discount: "37.5%"
  //       },
  //       {
  //         label: "Discounted",
  //         validTill: "2026-10-20",
  //         price: 9000,
  //         discount: "25%"
  //       },
  //       {
  //         label: "Normal",
  //         validTill: "2026-10-27",
  //         price: 12000,
  //         discount: "0%"
  //       }
  //     ],
  //     fullPricingTable: [
  //   {
  //     label: 'Early Bird',
  //     validTill: '2026-10-05',
  //     individualPrice: 7500,
  //     groupPricing: [
  //       { delegates: 3, discount: '10%', price: 20260 },
  //       { delegates: 5, discount: '15%', price: 31850 },
  //       { delegates: 10, discount: '20%', price: 60000 }
  //     ]
  //   },
  //   {
  //     label: 'Discounted',
  //     validTill: '2026-10-20',
  //     individualPrice: 9000,
  //     groupPricing: [
  //       { delegates: 3, discount: '10%', price: 24300 },
  //       { delegates: 5, discount: '15%', price: 38250 },
  //       { delegates: 10, discount: '20%', price: 72000 }
  //     ]
  //   },
  //   {
  //     label: 'Normal',
  //     validTill: '2026-10-27',
  //     individualPrice: 12000,
  //     groupPricing: [
  //       { delegates: 3, discount: '10%', price: 32400 },
  //       { delegates: 5, discount: '15%', price: 51000 },
  //       { delegates: 10, discount: '20%', price: 96000 }
  //     ]
  //   }
  // ],

  //     registerPath:'vip/professional',
  //   },

  //   {
  //     type: 'VIP Delegates (Group)',
  //     registration:'Group',
  //     groupCategory:'',
  //     features: [
  //       {
  //         title: 'Categories',
  //         points: [
  //           'Government / Defence / PSU\'s',
  //           'Organizations',
  //           'Institutions',
  //         ]
  //       },
  //       {
  //         title: 'Full Access to the Conclave',
  //         points: [
  //           'Entry to all keynote sessions, fireside chats, panel discussions, and masterclasses across all 3 days.',
  //           'Priority access to TechTalks, Innovation Showcases, and Spotlight Sessions by national and international thought leaders.',
  //         ]
  //       },
  //       {
  //         title: 'Knowledge & Learning',
  //         points: [
  //           'Complimentary participation in curated SKILLABLERS Masterclasses, featuring industry-led, career-focused content.',
  //           'Eligibility for STTC Certification of Participation – co-issued by organizing partners including CSI, DRDO, ISRO, and BrahMos.'
  //         ]
  //       },
  //       {
  //         title: 'Networking & Business Access',
  //         points: [
  //           'Entry to the Business Networking Lounge with opportunities to connect with C-level executives, government leaders, and academic visionaries.',
  //           'Option to pre-book B2B & B2I (Business to Institution) meetings via the conclave app.',
  //           'Access to Startup & Industry Matchmaking Zone for curated engagement with startups, CoEs, and innovation hubs.',
  //         ]
  //       },
  //       {
  //         title: 'Interactive & Immersive Zones',
  //         points: [
  //           'Guided walkthroughs of the TechTrust Experience Pavilion, showcasing live demos, immersive storytelling, and futuristic tech.',
  //           'Access to Phygital Knowledge Walls and real-time engagement zones powered by AI.'
  //         ]
  //       },
  //       {
  //         title: 'Delegate Kit & Privileges',
  //         points: [
  //           'Official STTC 2026 Delegate Kit including a smart badge, tech-enabled lanyard, souvenirs, and conclave handbook.',
  //           'Priority seating for select events (subject to availability).',
  //           'Exclusive digital resources post-event: session recordings, speaker decks, and curated industry insights.'
  //         ]
  //       },
  //       {
  //         title: 'Comfort & Hospitality',
  //         points: [
  //           'Complimentary access to refreshment zones and curated delegate-only networking dinners.',
  //           'Special offers from STTC hospitality partners for accommodation and transport.'
  //         ]
  //       }
  //     ],
  //     attend:'ACCESS ON ALL 3 DAYS',
  //     pricingTiers: [
  //       {
  //         label: "Early Bird",
  //         validTill: "2026-10-05",
  //         price: 7500,
  //         discount: "37.5%"
  //       },
  //       {
  //         label: "Discounted",
  //         validTill: "2026-10-20",
  //         price: 9000,
  //         discount: "25%"
  //       },
  //       {
  //         label: "Normal",
  //         validTill: "2026-10-27",
  //         price: 12000,
  //         discount: "0%"
  //       }
  //     ],
  //     fullPricingTable: [
  //   {
  //     label: 'Early Bird',
  //     validTill: '2026-10-05',
  //     individualPrice: 7500,
  //     groupPricing: [
  //       { delegates: 3, discount: '10%', price: 20260 },
  //       { delegates: 5, discount: '15%', price: 31850 },
  //       { delegates: 10, discount: '20%', price: 60000 }
  //     ]
  //   },
  //   {
  //     label: 'Discounted',
  //     validTill: '2026-10-20',
  //     individualPrice: 9000,
  //     groupPricing: [
  //       { delegates: 3, discount: '10%', price: 24300 },
  //       { delegates: 5, discount: '15%', price: 38250 },
  //       { delegates: 10, discount: '20%', price: 72000 }
  //     ]
  //   },
  //   {
  //     label: 'Normal',
  //     validTill: '2026-10-27',
  //     individualPrice: 12000,
  //     groupPricing: [
  //       { delegates: 3, discount: '10%', price: 32400 },
  //       { delegates: 5, discount: '15%', price: 51000 },
  //       { delegates: 10, discount: '20%', price: 96000 }
  //     ]
  //   }
  // ],

  //     registerPath:'vip/government',
  //   },
  {
    type: 'GOVERNMENT / DEFENCE / PSU\'s',
    registration: 'Group',
    groupCategory: '',
    features: [
      {
        markdown: `
Unlock the full potential of participation in sessions for Government, Defence, and PSU organizations. This opportunity ensures unified participation, bringing together insights from all four breakthrough technology domains shaping the future: **AI/ML**; **Cybersecurity**; **UAV/Robotics & Quantum Computing**.

With your delegates fully immersed in this high-impact track, your organization will:

- **Capture 360° insights** into the latest innovations and applications.  
- **Showcase strong presence** at the forefront of technology. 
- **Empower collaboration** between departments and with industry leaders.  
- **Future-proof expertise** by aligning with global innovation priorities.

Position your organization at the forefront of transformation – don’t just participate, lead the conversation across every emerging technology track.
      `.trim()
      },

    ],
    attend: ' ',
    pricingTiers: [
      {
        label: "Early Bird",
        validTill: "2025-12-21",
        price: 2500,
        discount: "37.5%"
      },
      {
        label: "Discounted",
        validTill: "2026-01-20",
        price: 3000,
        discount: "25%"
      },
      {
        label: "Normal",
        validTill: "2026-10-27",
        price: 3000,
        discount: "0%"
      }
    ],

    fullPricingTable: [
      {
        label: 'Early Bird',
        validTill: '2026-10-05',
        individualPrice: 2500,
        groupPricing: [
          { delegates: 3, discount: '10%', price: 6750 },
          { delegates: 5, discount: '15%', price: 10600 },
          { delegates: 10, discount: '20%', price: 20000 }
        ]
      },
      {
        label: 'Discounted',
        validTill: '2026-10-20',
        individualPrice: 3000,
        groupPricing: [
          { delegates: 3, discount: '10%', price: 8100 },
          { delegates: 5, discount: '15%', price: 12750 },
          { delegates: 10, discount: '20%', price: 24000 }
        ]
      },
      {
        label: 'Normal',
        validTill: '2026-10-27',
        individualPrice: 4000,
        groupPricing: [
          { delegates: 3, discount: '10%', price: 10800 },
          { delegates: 5, discount: '15%', price: 17000 },
          { delegates: 10, discount: '20%', price: 32000 }
        ]
      }
    ],

    registerPath: 'standard/government'
  }
  ,
  {
    type: 'ORGANIZATIONS',
    registration: 'Group',
    groupCategory: '',
    features: [


      {
        markdown: `
Empower your teams to seize every opportunity with corporate bulk delegate booking. Ensure your organization gains comprehensive exposure to the four technology frontiers driving business transformation: **AI/ML**; **Cybersecurity**; **UAV/Robotics & Quantum Computing**

With your delegate fully immersed in this high-impact track, your organization will:

- **Gain actionable insights** to fuel innovation and competitiveness.  
- **Build brand visibility** across multiple technology domains.  
- **Foster cross-functional learning** and intra-team collaboration.  
- **Strengthen leadership readiness** for the digital-first future.

Stay ahead of disruption – equip your teams to learn, connect, and lead across every frontier of technology.
      `.trim()
      },

    ],
    attend: ' ',
    pricingTiers: [
      {
        label: "Early Bird",
        validTill: "2025-12-21",
        price: 2500,
        discount: "37.5%"
      },
      {
        label: "Discounted",
        validTill: "2026-01-20",
        price: 3000,
        discount: "25%"
      },
      {
        label: "Normal",
        validTill: "2026-10-27",
        price: 3000,
        discount: "0%"
      }
    ],
    fullPricingTable: [
      {
        label: 'Early Bird',
        validTill: '2026-10-05',
        individualPrice: 2500,
        groupPricing: [
          { delegates: 3, discount: '10%', price: 6750 },
          { delegates: 5, discount: '15%', price: 10600 },
          { delegates: 10, discount: '20%', price: 20000 }
        ]
      },
      {
        label: 'Discounted',
        validTill: '2026-10-20',
        individualPrice: 3000,
        groupPricing: [
          { delegates: 3, discount: '10%', price: 8100 },
          { delegates: 5, discount: '15%', price: 12750 },
          { delegates: 10, discount: '20%', price: 24000 }
        ]
      },
      {
        label: 'Normal',
        validTill: '2026-10-27',
        individualPrice: 4000,
        groupPricing: [
          { delegates: 3, discount: '10%', price: 10800 },
          { delegates: 5, discount: '15%', price: 17000 },
          { delegates: 10, discount: '20%', price: 32000 }
        ]
      }
    ],

    registerPath: 'standard/industry',
  },

  {
    type: 'INSTITUTIONS',
    registration: 'Group',
    groupCategory: '',
    features: [
      {
        title: '',
        points: [
          'Enable your institution to be at the forefront of knowledge and innovation with institutional bulk delegate booking. By participating across all four technology frontiers - AI/ML; Cybersecurity; UAV/Robotics & Quantum Computing - both faculty and students can gain unparalleled exposure.',
          '18 Students & 2 Faculties'
        ]
      },
      {
        title: 'For Faculty Members',
        points: [
          'Stay industry-relevant with insights into cutting-edge technologies.',
          'Enrich teaching & curriculum with real-world case studies and applications.',
          'Build networks with industry experts, policymakers, and researchers.',
          'Shape future-ready programs aligned with global technology trends.',
        ]
      },
      {
        title: 'For Students',
        points: [
          'Explore emerging career pathways in high-demand technology domains.',
          'Gain hands-on exposure to real-world challenges and innovations.',
          'Interact with industry leaders and discover opportunities for internships, projects, and placements.',
          'Future-proof their careers by aligning skills with next-gen technologies.',
        ]
      },
      {
        title: '',
        points: [
          'Bulk delegate participation ensures your institution’s faculty and students are not just learners, but contributors to the innovation ecosystem.'
        ]
      },
    ],
    attend: ' ',
    pricingTiers: [
      {
        label: "Early Bird",
        validTill: "2025-12-21",
        price: 50000,
        discount: "37.5%"
      },
      {
        label: "Discounted",
        validTill: "2026-01-20",
        price: 50000,
        discount: "25%"
      },
      {
        label: "Normal",
        validTill: "2026-10-27",
        price: 50000,
        discount: "0%"
      }
    ],
    fullPricingTable: [
      {
        label: 'Early Bird',
        validTill: '2026-10-05',
        compositePricing: [
          { faculty: 3, students: 3, price: 7750 },
          { faculty: 3, students: 5, price: 9300 },
          { faculty: 3, students: 10, price: 13050 },
          { faculty: 5, students: 3, price: 10650 },
          { faculty: 5, students: 5, price: 12200 },
          { faculty: 5, students: 10, price: 15950 },
          { faculty: 10, students: 3, price: 17700 },
          { faculty: 10, students: 5, price: 19250 },
          { faculty: 10, students: 10, price: 23000 },
        ],
        note: 'Composite group pricing includes both faculty and students.'
      },
      {
        label: 'Discounted',
        validTill: '2026-10-20',
        compositePricing: [
          { faculty: 3, students: 3, price: 9250 },
          { faculty: 3, students: 5, price: 11150 },
          { faculty: 3, students: 10, price: 15650 },
          { faculty: 5, students: 3, price: 12750 },
          { faculty: 5, students: 5, price: 14650 },
          { faculty: 5, students: 10, price: 19150 },
          { faculty: 10, students: 3, price: 21200 },
          { faculty: 10, students: 5, price: 23100 },
          { faculty: 10, students: 10, price: 27600 },
        ],
        note: 'Composite group pricing includes both faculty and students.'
      },
      {
        label: 'Normal',
        validTill: '2026-10-27',
        compositePricing: [
          { faculty: 3, students: 3, price: 12400 },
          { faculty: 3, students: 5, price: 14900 },
          { faculty: 3, students: 10, price: 20900 },
          { faculty: 5, students: 3, price: 17050 },
          { faculty: 5, students: 5, price: 19550 },
          { faculty: 5, students: 10, price: 25550 },
          { faculty: 10, students: 3, price: 28300 },
          { faculty: 10, students: 5, price: 30800 },
          { faculty: 10, students: 10, price: 36800 },
        ],
        note: 'Composite group pricing includes both faculty and students.'
      }
    ],

    registerPath: 'standard/institution',
  },

  {
    type: 'Individual Delegates',
    registration: 'Individual',
    groupCategory: '',
    features: [
      //  {
      //   title: 'Categories',
      //   points: [
      //     'Government / Defence / PSU\'s Personnel',
      //    'Industry Professionals',
      //     'Institutions Professionals',

      //   ]
      // },
      // {
      //   title: 'Defence Personnel Delegate Privileges',
      //   points: [
      //      'Paid access to SKILLABLERS Masterclasses & Academic Roundtables',
      //     'Reserved seating in Security, Aerospace & AI panels',
      //     'Access to closed-door Defence Roundtables (on invitation)',
      //     'Opportunity to showcase tech innovations in the Defence Innovation Hall'
      //   ]
      // },
      // {
      //   title: 'Industry Professional Delegate Privileges',
      //   points: [
      //     'Access to Leadership Keynotes, Fireside Chats & Strategic Panels',
      //     'Invitations to B2B Connects and CXO Roundtables',
      //     'Access to the Innovation Showcase Zone',
      //     'Use of Business Networking Lounge',
      //     'Early access to Partner Pitch Decks & Investment Opportunities'
      //   ]
      // },
      // {
      //   title: 'Institution Professional Delegate Privileges',
      //   points: [
      //     'Paid access to SKILLABLERS Masterclasses & Academic Roundtables',
      //     'Participation in the STTC Skill Connect Tracks',
      //     'Eligibility to nominate students for Future Stars Showcase',
      //     'Institution-Industry Networking Session Access'
      //   ]
      // }

      {
        title: 'Individual Delegates',
        markdown: `
- **Gain deep insights** into breakthrough technologies shaping tomorrow.  
- **Exposure to real-world applications**, live demos, and expert-led discussions.  
- **Network with industry leaders**, innovators, founders, researchers, and senior decision-makers.  
- **Access collaboration possibilities** for projects, consulting, research, and innovation-led partnerships.
  `.trim()
      },
    ],
    attend: ' ',
    pricingTiers: [
      {
        label: "Early Bird",
        validTill: "2025-12-21",
        price: 2500,
        discount: "37.5%"
      },
      {
        label: "Discounted",
        validTill: "2026-01-20",
        price: 3000,
        discount: "25%"
      },
      {
        label: "Normal",
        validTill: "2026-10-27",
        price: 3000,
        discount: "0%"
      }
    ],
    fullPricingTable: [
      {
        label: 'DEFENCE / PSU / STARTUP / Industry Professionals',
        type: 'standard',
        tiers: [
          {
            label: 'Early Bird',
            validTill: '2026-10-05',
            discount: '37.5%',
            individualPrice: 2500,
            groupPricing: [
              { delegates: 3, discount: '10%', price: 6750 },
              { delegates: 5, discount: '15%', price: 10600 },
              { delegates: 10, discount: '20%', price: 20000 }
            ]
          },
          {
            label: 'Discounted',
            validTill: '2026-10-20',
            discount: '25%',
            individualPrice: 3000,
            groupPricing: [
              { delegates: 3, discount: '10%', price: 24300 },
              { delegates: 5, discount: '15%', price: 38250 },
              { delegates: 10, discount: '20%', price: 72000 }
            ]
          },
          {
            label: 'Normal',
            validTill: '2026-10-27',
            discount: '0%',
            individualPrice: 4000,
            groupPricing: [
              { delegates: 3, discount: '10%', price: 32400 },
              { delegates: 5, discount: '15%', price: 51000 },
              { delegates: 10, discount: '20%', price: 96000 }
            ]
          }
        ]
      },
      {
        label: 'Institution Faculty (Professional)',
        type: 'institution',
        tiers: [
          {
            label: 'Early Bird',
            validTill: '2026-10-05',
            discount: '37.5%',
            individualPrice: 1850,
            groupPricing: [
              { delegates: 3, discount: '10%', price: 5050 },
              { delegates: 5, discount: '15%', price: 7950 },
              { delegates: 10, discount: '20%', price: 15000 }
            ]
          },
          {
            label: 'Discounted',
            validTill: '2026-10-20',
            discount: '25%',
            individualPrice: 2250,
            groupPricing: [
              { delegates: 3, discount: '10%', price: 6050 },
              { delegates: 5, discount: '15%', price: 9550 },
              { delegates: 10, discount: '20%', price: 18000 }
            ]
          },
          {
            label: 'Normal',
            validTill: '2026-10-27',
            discount: '0%',
            individualPrice: 3000,
            groupPricing: [
              { delegates: 3, discount: '10%', price: 8100 },
              { delegates: 5, discount: '15%', price: 12750 },
              { delegates: 10, discount: '20%', price: 24000 }
            ]
          }
        ]
      }
    ],
    registerPath: 'standard/professional',
  },
  {
    type: 'Institutions Professional (Faculty) Delegates',
    registration: 'Individual',
    groupCategory: '',
    features: [
      //  {
      //   title: 'Categories',
      //   points: [
      //     'Government / Defence / PSU\'s Personnel',
      //    'Industry Professionals',
      //     'Institutions Professionals',

      //   ]

      {
        title: 'Institution Professional Delegate Privileges',
        markdown: `
- **Stay industry-relevant** with insights into cutting-edge technologies.  
- **Enrich teaching & curriculum** with real-world case studies and applications.  
- **Build networks** with industry experts, policymakers, and researchers.  
- **Shape future-ready programs** aligned with global technology trends.
  `.trim()
        // points: [
        //   'Paid access to SKILLABLERS Masterclasses & Academic Roundtables',
        //   'Participation in the STTC Skill Connect Tracks',
        //   'Eligibility to nominate students for Future Stars Showcase',
        //   'Institution-Industry Networking Session Access'
        // ]
      }
    ],
    attend: ' ',
    pricingTiers: [
      {
        label: "Early Bird",
        validTill: "2025-12-21",
        price: 2500,
        discount: "37.5%"
      },
      {
        label: "Discounted",
        validTill: "2026-01-20",
        price: 3000,
        discount: "25%"
      },
      {
        label: "Normal",
        validTill: "2026-10-27",
        price: 3000,
        discount: "0%"
      }
    ],
    fullPricingTable: [
      {
        label: 'DEFENCE / PSU / STARTUP / Industry Professionals',
        type: 'standard',
        tiers: [
          {
            label: 'Early Bird',
            validTill: '2026-10-05',
            discount: '37.5%',
            individualPrice: 2500,
            groupPricing: [
              { delegates: 3, discount: '10%', price: 6750 },
              { delegates: 5, discount: '15%', price: 10600 },
              { delegates: 10, discount: '20%', price: 20000 }
            ]
          },
          {
            label: 'Discounted',
            validTill: '2026-10-20',
            discount: '25%',
            individualPrice: 3000,
            groupPricing: [
              { delegates: 3, discount: '10%', price: 24300 },
              { delegates: 5, discount: '15%', price: 38250 },
              { delegates: 10, discount: '20%', price: 72000 }
            ]
          },
          {
            label: 'Normal',
            validTill: '2026-10-27',
            discount: '0%',
            individualPrice: 4000,
            groupPricing: [
              { delegates: 3, discount: '10%', price: 32400 },
              { delegates: 5, discount: '15%', price: 51000 },
              { delegates: 10, discount: '20%', price: 96000 }
            ]
          }
        ]
      },
      {
        label: 'Institution Faculty (Professional)',
        type: 'institution',

        tiers: [
          {
            label: 'Early Bird',
            validTill: '2026-10-05',
            discount: '37.5%',
            individualPrice: 1850,
            groupPricing: [
              { delegates: 3, discount: '10%', price: 5050 },
              { delegates: 5, discount: '15%', price: 7950 },
              { delegates: 10, discount: '20%', price: 15000 }
            ]
          },
          {
            label: 'Discounted',
            validTill: '2026-10-20',
            discount: '25%',
            individualPrice: 2250,
            groupPricing: [
              { delegates: 3, discount: '10%', price: 6050 },
              { delegates: 5, discount: '15%', price: 9550 },
              { delegates: 10, discount: '20%', price: 18000 }
            ]
          },
          {
            label: 'Normal',
            validTill: '2026-10-27',
            discount: '0%',
            individualPrice: 3000,
            groupPricing: [
              { delegates: 3, discount: '10%', price: 8100 },
              { delegates: 5, discount: '15%', price: 12750 },
              { delegates: 10, discount: '20%', price: 24000 }
            ]
          }
        ]
      }
    ],
    registerPath: 'standard/professional',
  },


  // {
  //   type: 'Youth Delegates - Aspiring Professional',
  //   registration:'Individual',
  //   groupCategory:'Organizations',
  //   features: [

  //     {
  //       title: 'Privileges',
  //       points: [
  //         'Access to Entrepreneurship Panels & Startup Demo Zones',
  //         'Eligibility for Youth Challenge & Idea Pitch Battles',
  //         'Participation in Skillablers Career Bootcamps',
  //         'Single View Profile (SVP) listing in Youth Talent Registry',
  //         'Access to Delegate Lounge & Networking Corners'
  //       ]
  //     }
  //   ],
  //   attend:'',
  //   pricingTiers: [
  //      {
  //         label: "Early Bird",
  //         validTill: "2025-12-21",
  //         price: 1500,
  //         discount: "37.5%"
  //       },
  //       {
  //         label: "Discounted",
  //         validTill: "2026-01-20",
  //         price: 1500,
  //         discount: "25%"
  //       },
  //     {
  //       label: "Normal",
  //       validTill: "2026-10-27",
  //       price: 1500,
  //       discount: "0%"
  //     }
  //   ],
  //   fullPricingTable: [
  //     {
  //       label: "Students - Early Bird",
  //       validTill: "2026-10-05",
  //       individualPrice: 1000,
  //       groupPricing: [] // No group pricing
  //     },
  //     {
  //       label: "Students - Discounted",
  //       validTill: "2026-10-20",
  //       individualPrice: 1200,
  //       groupPricing: []
  //     },
  //     {
  //       label: "Students - Normal",
  //       validTill: "2026-10-27",
  //       individualPrice: 1600,
  //       groupPricing: []
  //     },
  //     {
  //       label: "Aspiring Professionals – Early Bird",
  //       validTill: "2026-10-05",
  //       individualPrice: 1500,
  //       groupPricing: []
  //     },
  //     {
  //       label: "Aspiring Professionals – Discounted",
  //       validTill: "2026-10-20",
  //       individualPrice: 1850,
  //       groupPricing: []
  //     },
  //     {
  //       label: "Aspiring Professionals – Normal",
  //       validTill: "2026-10-27",
  //       individualPrice: 2500,
  //       groupPricing: []
  //     }
  //   ],
  //   registerPath: 'standard/youth',
  // },
  //  {
  //   type: 'Youth Delegates - HEI Student',
  //   registration:'Individual',
  //   groupCategory:'Higher Education Institutions',
  //   features: [

  //     {
  //       title: 'Privileges',
  //       points: [
  //         '100 Students only. First Come First Serve',
  //         'Access to Entrepreneurship Panels & Startup Demo Zones',
  //         'Eligibility for Youth Challenge & Idea Pitch Battles',
  //         'Participation in Skillablers Career Bootcamps',
  //         'Single View Profile (SVP) listing in Youth Talent Registry',
  //         'Access to Delegate Lounge & Networking Corners'
  //       ]
  //     }
  //   ],
  //   attend:' ',
  //   pricingTiers: [
  //      {
  //         label: "Early Bird",
  //         validTill: "2025-12-21",
  //         price: 1500,
  //         discount: "37.5%"
  //       },
  //       {
  //         label: "Discounted",
  //         validTill: "2026-01-20",
  //         price: 1500,
  //         discount: "25%"
  //       },
  //     {
  //       label: "Normal",
  //       validTill: "2026-10-27",
  //       price: 1500,
  //       discount: "0%"
  //     }
  //   ],
  //   fullPricingTable: [
  //     {
  //       label: "Students - Early Bird",
  //       validTill: "2026-10-05",
  //       individualPrice: 1000,
  //       groupPricing: [] // No group pricing
  //     },
  //     {
  //       label: "Students - Discounted",
  //       validTill: "2026-10-20",
  //       individualPrice: 1200,
  //       groupPricing: []
  //     },
  //     {
  //       label: "Students - Normal",
  //       validTill: "2026-10-27",
  //       individualPrice: 1600,
  //       groupPricing: []
  //     },
  //     {
  //       label: "Aspiring Professionals – Early Bird",
  //       validTill: "2026-10-05",
  //       individualPrice: 1500,
  //       groupPricing: []
  //     },
  //     {
  //       label: "Aspiring Professionals – Discounted",
  //       validTill: "2026-10-20",
  //       individualPrice: 1850,
  //       groupPricing: []
  //     },
  //     {
  //       label: "Aspiring Professionals – Normal",
  //       validTill: "2026-10-27",
  //       individualPrice: 2500,
  //       groupPricing: []
  //     }
  //   ],
  //   registerPath: 'standard/youth',
  // },
  //   {
  //   type: 'School Student Delegates',
  //   registration:'Group',
  //   groupCategory:'',
  //   features: [
  //     {
  //       title: 'Privileges',
  //       points: [
  //         'Entry to Emerging Tech / Future Skills Showcases (AI, Robotics, SpaceTech demos)',
  //         'Participation in Skillablers Industry Awareness Quiz (SKL Quiz) & Innovation Challenges',
  //         'Guided walk-through of Immersive Tech Pavilions',
  //         'STTC 2026 Young Explorer Certificate',
  //         'Two faculty members per institution are eligible for complimentary entry with group registration'

  //       ]
  //     }
  //   ],
  //   registerPath: 'standard/school',
  //   note: 'Individual registration not available for school students. Group registration only.',
  //   attend:'ACCESS ON 3rd DAY',
  //     pricingTiers: [
  //     {
  //       label: "Early Bird",
  //       validTill: "2026-10-05",
  //       price: 175,
  //       discount: "37.5%"
  //     },
  //     {
  //       label: "Discounted",
  //       validTill: "2026-10-20",
  //       price: 225,
  //       discount: "25%"
  //     },
  //     {
  //       label: "Normal",
  //       validTill: "2026-10-27",
  //       price: 300,
  //       discount: "0%"
  //     }
  //   ],
  //   fullPricingTable: [
  //     {
  //       label: 'Early Bird',
  //       validTill: '2026-10-05',
  //       groupOnlyPricing: [
  //         { delegates: 50, discount: '10%', price: 8400 },
  //         { delegates: 75, discount: '15%', price: 11950 },
  //         { delegates: 100, discount: '20%', price: 15000 }
  //       ],
  //       basePrice: 175,
  //       discount: '37.5%'
  //     },
  //     {
  //       label: 'Discounted',
  //       validTill: '2026-10-20',
  //       groupOnlyPricing: [
  //         { delegates: 50, discount: '10%', price: 10100 },
  //         { delegates: 75, discount: '15%', price: 14300 },
  //         { delegates: 100, discount: '20%', price: 18000 }
  //       ],
  //       basePrice: 225,
  //       discount: '25%'
  //     },
  //     {
  //       label: 'Normal',
  //       validTill: '2026-10-27',
  //       groupOnlyPricing: [
  //         { delegates: 50, discount: '10%', price: 13500 },
  //         { delegates: 75, discount: '15%', price: 19100 },
  //         { delegates: 100, discount: '20%', price: 24000 }
  //       ],
  //       basePrice: 300,
  //       discount: '0%'
  //     }
  //   ]
  // }

]

// Added on 28th July 2025

export const partnerCategories = [
  { id: 1, title: "Title Partners", order: 1, display: false },
  { id: 2, title: "Technology Focus Partners", order: 5, display: false },
  { id: 3, title: "Platinum Partners", order: 1, display: true },
  { id: 4, title: "Gold Partners", order: 2, display: true },
  { id: 5, title: "Silver Partners", order: 3, display: true },
  { id: 6, title: "SKL Masterclass Partners", order: 6, display: false },
  { id: 7, title: "SKL IAQ Partners", order: 7, display: false },
  { id: 8, title: "SKL Future Stars Partners", order: 8, display: false },
  { id: 9, title: "Delegate Kit Branding Partners", order: 9, display: false },
  { id: 10, title: "Networking Dinner Branding Partners", order: 10, display: false },
  // ... other categories
];


export const subFocusAreas = [
  { id: 1, name: "DEF-TECH", order: 1 },
  { id: 2, name: "INFRA-TECH", order: 2 },
  { id: 3, name: "HEALTH-TECH", order: 3 },
  { id: 4, name: "BFSI-TECH", order: 4 },
  { id: 5, name: "SKILL-TECH", order: 5 },
  { id: 6, name: "AI / ML", order: 6 },
  { id: 7, name: "Cybersecurity", order: 7 },
  { id: 8, name: "UAV & Robotics", order: 8 },
  { id: 9, name: "Quantum Computing", order: 9 },
  // etc.
];

export const subFocuspartnerCategoriesMappings = [
  {
    categoryId: 2,             // Technology Focus Partners
    subFocusId: 6,             // AI / ML
  },
  {
    categoryId: 2,             // Technology Focus Partners
    subFocusId: 7,             // Cybersecurity
  },
  {
    categoryId: 2,             // Technology Focus Partners
    subFocusId: 8,             // UAV / Robotics
  },
  {
    categoryId: 2,             // Technology Focus Partners
    subFocusId: 9,             // Quantum Computing
  },
  {
    categoryId: 3,             // Platinum Partners
    subFocusId: 1,             // DEF-TECH
  },
  {
    categoryId: 3,             // Platinum Partners
    subFocusId: 2,             // INFRA-TECH
  },
  {
    categoryId: 3,             // Platinum Partners
    subFocusId: 3,             // HEALTH-TECH
  },
  {
    categoryId: 3,             // Platinum Partners
    subFocusId: 4,             // BFSI-TECH
  },
  {
    categoryId: 3,             // Platinum Partners
    subFocusId: 5,             // SKILL-TECH
  },
  {
    categoryId: 3,             // Platinum Partners
    subFocusId: 6,             // AI / ML
  },
  {
    categoryId: 3,             // Platinum Partners
    subFocusId: 7,             // Cybersecurity
  },
  {
    categoryId: 3,             // Platinum Partners
    subFocusId: 8,             // UAV / Robotics
  },
  {
    categoryId: 3,             // Platinum Partners
    subFocusId: 9,             // Quantum Computing
  },
  {
    categoryId: 4,             // Gold Partners
    subFocusId: 1,             // DEF-TECH
  },
  {
    categoryId: 4,             // Gold Partners
    subFocusId: 2,             // INFRA-TECH
  },
  {
    categoryId: 4,             // Gold Partners
    subFocusId: 3,             // HEALTH-TECH
  },
  {
    categoryId: 4,             // Gold Partners
    subFocusId: 4,             // BFSI-TECH
  },
  {
    categoryId: 4,             // Gold Partners
    subFocusId: 5,             // SKILL-TECH
  },
  {
    categoryId: 4,             // Gold Partners
    subFocusId: 6,             // AI / ML
  },
  {
    categoryId: 4,             // Gold Partners
    subFocusId: 7,             // Cybersecurity
  },
  {
    categoryId: 4,             // Gold Partners
    subFocusId: 8,             // UAV / Robotics
  },
  {
    categoryId: 4,             // Gold Partners
    subFocusId: 9,             // Quantum Computing
  },
  {
    categoryId: 5,             // Silver Partners
    subFocusId: 1,             // DEF-TECH
  },
  {
    categoryId: 5,             // Silver Partners
    subFocusId: 2,             // INFRA-TECH
  },
  {
    categoryId: 5,             // Silver Partners
    subFocusId: 3,             // HEALTH-TECH
  },
  {
    categoryId: 5,             // Silver Partners
    subFocusId: 4,             // BFSI-TECH
  },
  {
    categoryId: 5,             // Silver Partners
    subFocusId: 5,             // SKILL-TECH
  },
  {
    categoryId: 5,             // Silver Partners
    subFocusId: 6,             // AI / ML
  },
  {
    categoryId: 5,             // Silver Partners
    subFocusId: 7,             // Cybersecurity
  },
  {
    categoryId: 5,             // Silver Partners
    subFocusId: 8,             // UAV / Robotics
  },
  {
    categoryId: 5,             // Silver Partners
    subFocusId: 9,             // Quantum Computing
  },
  // More rows
];


export const partnerTypes = [
  { id: 1, name: "Corporate", order: 1 },
  { id: 2, name: "Institution", order: 2 },
  { id: 3, name: "Government", order: 3 },
];


export const partnersParticipating = [
  {
    id: 1,
    name: "EDC CTS EXOTYQ  ",
    logo: EDC_Exotyq_Taurus,
    url: "https://drdo.gov.in",
    display: true,
    order: 1,
    tagline: 'Balasya Mulam Vigyanam',
    description: ''
  },
  {
    id: 2,
    name: "Platinum – Corporate Partners",
    logo: '',
    url: "",
    display: true,
    order: 2,
    tagline: '',
    description: 'Confirmed partners to be unveiled shortly. Watch this space.'
  },
  {
    id: 3,
    name: "Gold Partners",
    logo: '',
    url: "",
    display: true,
    order: 2,
    tagline: '',
    description: 'Partnering with forward-looking organizations to drive innovation.'
  },
  {
    id: 4,
    name: "Silver Partner",
    logo: '',
    url: "https://drdo.gov.in",
    display: true,
    order: 2,
    tagline: '',
    description: 'Meaningful partnerships are built on shared vision. Our partners will be revealed soon as we engage with organizations committed to innovation, trust, and technology-led transformation.'
  },
  {
    id: 5,
    name: "Title Partner",
    logo: '',
    url: "https://drdo.gov.in",
    display: true,
    order: 2,
    tagline: '',
    description: 'To be announced. Discussions underway with national technology leaders.'
  },
  {
    id: 6,
    name: "Institution Partners",
    logo: '',
    url: "https://drdo.gov.in",
    display: true,
    order: 2,
    tagline: '',
    description: 'Conversations in progress with leading academic and R&D institutions.'
  },
  {
    id: 7,
    name: "Government / Defence / PSU Partners",
    logo: '',
    url: "https://drdo.gov.in",
    display: true,
    order: 2,
    tagline: '',
    description: 'Formal engagements are underway and we are currently awaiting official permissions and endorsements. Details will be updated here as and when official confirmations are received.'
  }
  // {
  //   id: 2,
  //   name: "Exotyq",
  //   logo: Exotyq,
  //   url: "https://Exotyq.com",
  //   display: true,
  //   order: 3,
  //   tagline: 'Leading the way in technology education and innovation events',
  //   description :''
  // },
  // {
  //   id: 3,
  //   name: "EDC CTS",
  //   logo: EDC,
  //   url: "https://edccts.com",
  //   display: true,
  //   order: 3,
  //   tagline: 'Leading the way in technology education and innovation events',
  //   description :''
  // },
  // etc.
];

export const partnerMappings = [
  {
    partnerId: 1,              // DRDO
    categoryId: 3,             // Platinum Partners
    subFocusId: 1,             // DEF-TECH
    partnerTypeId: 3,          // Government
  },
  {
    partnerId: 2,              // IIT Madras
    categoryId: 3,
    subFocusId: 1,
    partnerTypeId: 2,
  },
  {
    partnerId: 3,              // L&T
    categoryId: 4,
    subFocusId: 1,
    partnerTypeId: 1,
  },

  {
    partnerId: 4,              // L&T
    categoryId: 5,
    subFocusId: 1,
    partnerTypeId: 1,
  },
  {
    partnerId: 5,              // L&T
    categoryId: 1,
    subFocusId: 1,
    partnerTypeId: 1,
  },
  {
    partnerId: 6,              // L&T
    categoryId: 1,
    subFocusId: 1,
    partnerTypeId: 2,
  },
  {
    partnerId: 7,              // L&T
    categoryId: 1,
    subFocusId: 1,
    partnerTypeId: 3,
  },
  // More rows
];



// Inside conclaveData.js
export const streams = {
  heading: "STTC 2026 Live & On-Demand",
  headingDescription: "Watch live sessions and recordings from the Strategic TechTrust Conclave 2026",
  content: [
    {
      id: "stream1",
      title: "Opening Keynote",
      type: "live", // 'live' or 'vod'
      startTime: "2026-08-10T10:00:00+05:30",
      playerUrl: "https://example.com/live/playlist.m3u8", // HLS URL
      thumbnail: "/assets/images/streams/keynote.jpg",
      display: true,
      order: 1
    },
    {
      id: "stream2",
      title: "Panel Discussion - AI & Sustainability",
      type: "vod",
      startTime: "2026-08-09T14:00:00+05:30",
      playerUrl: "https://example.com/vod/panel.m3u8",
      thumbnail: "/assets/images/streams/panel.jpg",
      display: true,
      order: 2
    }
  ]
};

// Added on 5th Dec 2025

export const sttcSchedule = {
  event: {
    title: "Program Schedule",
    track: "Defence Tech",
    theme: "Uniting minds to lead emerging technologies in defence tech in line with PM’s vision of VIKSIT Bharat.",
    venue: "Taj MG Road, Trinity Circle, Bengaluru",
    date: "Wednesday, January 21, 2026",
    time: "08:30 AM – 06:00 PM"
  },

  specialSegments: {
    specialSegmentscategory: [
      {
        categorytitle: "Special Segments",
        items: [
          {
            title: "Innovation Pods",
            description:
              "5 thematic pods – AI/ML • Cyber Defence • UAVs • Quantum • Dual-Use Startups."
          },
          {
            title: "Recognition Wall",
            description:
              "A dedicated visual wall displaying all sponsor Institutions and Corporate logos."
          }
        ]
      }
    ]
  },

  sessions: [
    /* -------------------------------------------------- */
    /* Registration */
    /* -------------------------------------------------- */
    {
      time: "08:00 – 09:00 AM",
      title: "Registration & Networking Coffee",
      format: "Registration / Networking",
      description:
        "Delegate arrivals, informal networking among distinguished invitees, invited speakers, panelists, delegates from Department of Space, DRDO, PSUs, corporates & academia.",
      speakers: { label: "Speakers", list: [] },
      moderator: { label: "Moderator", list: [] }
    },

    /* -------------------------------------------------- */
    /* Inaugural Dance */
    /* -------------------------------------------------- */
    {
      time: "09:00 – 09:10 AM",
      title: "Invocatory Dance – Brahmanjali",
      format: "Inaugural Session",
      description:
        "Traditional Kuchipudi invocatory dance performance.",
      speakers: {
        label: "Dance Performance By",
        list: [
          {
            name: "Aishwarya Madhav",
            designation: "Kuchipudi Artist",
            organization: "",
            expertise: "",
            display: true,
            order: 1
          }
        ]
      },
      moderator: { label: "Moderator", list: [] }
    },

    /* -------------------------------------------------- */
    /* Inaugural Session */
    /* -------------------------------------------------- */
    {
      time: "09:10 – 10:10 AM",
      title:
        "Inaugural Session — Uniting Minds to Lead Emerging Technologies in Defence Tech in line with PM’s Vision of VIKSIT Bharat",
      format: "Inaugural Session",
      description:
        "Keynote addresses and strategic vision talks by national leadership, defence scientists, and space & aerospace visionaries.",
      speakers: {
        label: "Distinguished Speakers",
        list: [
          {
            name: "Chief Guest - Shri. Rajnath Singh",
            designation: "Hon’ble Defence Minister",
            organization: "Government of India",
            expertise: "",
            display: false,
            order: 1
          },
          {
            name: "Chief Guest - Shri. Tuhin Sinha",
            designation: "Author & National Spokesperson",
            organization: "BJP",
            expertise: "",
            display: true,
            order: 2
          },
          {
            name: "Guest of Honor - Dr. K. Rajalakshmi Menon",
            designation: "DG – Aeronautical Systems",
            organization: "DRDO",
            expertise: "",
            display: true,
            order: 3
          },
          {
            name: "Guest of Honor - Dr. Prahlad Rama Rao",
            designation: "Padma Shri Awardee, Former Director",
            organization: "DRDO",
            expertise: "",
            display: true,
            order: 4
          },
          {
            name: "Guest of Honor - Shubhanshu Shukla",
            designation: "Group Captain",
            organization: "ISRO / Indian Air Force",
            expertise: "",
            display: false,
            order: 5
          },
          {
            name: "Guest of Honor - Dr. Samir V. Kamat",
            designation: "Secretary, Dept. of Defence R&D & Chairman",
            organization: "DRDO",
            expertise: "Pre-recorded address",
            display: true,
            order: 6
          },
          {
            name: "Guest of Honor - Dr. V. Narayanan",
            designation: "Secretary, Dept. of Space & Chairman",
            organization: "ISRO",
            expertise: "Pre-recorded address",
            display: true,
            order: 7
          },
          {
            name: "Guest of Honor - Dr. Kota Harinarayana",
            designation: "Padma Shri Awardee, Former Program Director",
            organization: "ADA / DRDO",
            expertise: "Pre-recorded address",
            display: false,
            order: 8
          }
        ]
      },
      moderator: { label: "Moderator", list: [] }
    },

    /* -------------------------------------------------- */
    /* Break */
    /* -------------------------------------------------- */
    {
      time: "10:10 – 10:30 AM",
      title: "High Tea",
      format: "Break",
      description: "Networking refreshment break.",
      speakers: { label: "Speakers", list: [] },
      moderator: { label: "Moderator", list: [] }
    },

    /* -------------------------------------------------- */
    /* Parallel Sessions – Track 1 & 2 */
    /* -------------------------------------------------- */
    {
      //slotId: "S5",
      track: "Track 1",
      time: "10:30 – 11:45 AM",
      title: "UAV / Robotics — Advances in UAV & Robotics for Aerospace & Defence",
      format: "Panel Discussion + Interactive Session",
      description:
        "From Concept to Mission Readiness: Digital Engineering of UAV Systems.",
      speakers: {
        label: "Distinguished Panelists",
        list: [
          { name: "Dr. Abhay A. Pashilkar", designation: "Director", organization: "CSIR-NAL", expertise: "", display: true, order: 1 },
          { name: "Shri. V. K. Prabhulla Chandran", designation: "Honorary Advisor to DG", organization: "ADA", expertise: "", display: true, order: 2 },
          { name: "Dr. R. K. Ramanathan", designation: "Former Project Director", organization: "ADA", expertise: "", display: true, order: 3 },
          { name: "Shri. Vijay R", designation: "DGM (Design)", organization: "ARDC, HAL", expertise: "", display: true, order: 4 },
          { name: "Shri. Jithesh Sachdeva", designation: "Scientist G", organization: "ADE, DRDO", expertise: "", display: true, order: 5 },
          { name: "Dr. Venkateswaran PS", designation: "Technical Lead – Academics", organization: "CADFEM", expertise: "", display: true, order: 6 }
        ]
      },
      moderator: {
        label: "Chaired & Moderated By",
        list: [
          {
            name: "Dr. K. Rajalakshmi Menon",
            designation: "DG – Aeronautical Systems",
            organization: "DRDO",
            expertise: "",
            display: true,
            order: 1
          }
        ]
      }
    },

    {
      //slotId: "S5",
      track: "Track 2",
      time: "11:45 – 01:00 PM",
      title: "Quantum Computing & Semiconductor — Research, Strategy & Future",
      format: "Panel Discussion + Interactive Session",
      description:
        "Current Research, Strategic Importance, and Future Development.",
      speakers: {
        label: "Distinguished Panelists",
        list: [
          { name: "Dr. Gopal Krishna Patra", designation: "Director", organization: "CSIR-4PI", expertise: "", display: true, order: 1 },
          { name: "Shri. G. Sathish Kumar", designation: "Sci/Eng-SG", organization: "SDSC SHAR", expertise: "", display: true, order: 2 },
          { name: "Shri. Jayakumar J", designation: "Consultant", organization: "Semiconductor Domain", expertise: "", display: true, order: 3 },
          { name: "Shri. Manish", designation: "Industry Expert", organization: "Qualcomm", expertise: "", display: true, order: 4 },
          { name: "Prof. Dr. G. Raghavan", designation: "Director of school of quantum technology ", organization: "", expertise: "", display: true, order: 5 },
          { name: "Speaker from DRDO", designation: "", organization: "DRDO", expertise: "", display: false, order: 6 },
          { name: "Speaker from Miphi", designation: "", organization: "Miphi", expertise: "", display: false, order: 7 }
        ]
      },
      moderator: {
        label: "Chaired & Moderated By",
        list: [
          {
            name: "Prof. Baladitya Suri",
            designation: "Associate Professor, Department of Instrumentation & Applied Physics",
            organization: "IISc Bengaluru",
            expertise: "",
            display: true,
            order: 1
          }
        ]
      }
    },

    /* -------------------------------------------------- */
    /* Invited Talk */
    /* -------------------------------------------------- */
    // {
    //   time: "12:30 – 01:00 PM",
    //   title: "Invited Talk — Semiconductors Role in Space Exploration",
    //   format: "Invited Talk",
    //   description: "Role of semiconductor technologies in space exploration.",
    //   speakers: {
    //     label: "Invited Speaker",
    //     list: [
    //       {
    //         name: "Shri. G. Sathish Kumar",
    //         designation: "Sci/Eng-SG",
    //         organization: "SDSC SHAR",
    //         expertise: "",
    //         display: true,
    //         order: 1
    //       }
    //     ]
    //   },
    //   moderator: { label: "Moderator", list: [] }
    // },

    /* -------------------------------------------------- */
    /* Lunch */
    /* -------------------------------------------------- */
    {
      time: "01:00 – 02:00 PM",
      title: "Networking lunch",
      format: "Lunch",
      description: "",
      speakers: { label: "Speakers", list: [] },
      moderator: { label: "Moderator", list: [] }
    },


    /* -------------------------------------------------- */
    /* Track 3 — Invited Talks */
    /* -------------------------------------------------- */
    {
      //slotId: "S9A",
      track: "Track 3",
      time: "02:00 – 02:30 PM",
      title: "AI / ML Technologies for Next Generation Defence Systems",
      format: "Invited Talks",
      description:
        "Expert talks on AI/ML technologies, human–AI interaction, and next-generation defence platforms.",
      speakers: {
        label: "Invited Speakers",
        list: [

          {
            name: "Shri. Ashwin Chandran",
            designation: "Software Development Manager",
            organization: "AWS OpenSearch, Seattle, USA",
            expertise:
              "Cracking the Code of Human–AI Interaction — Peeking under the hood of today’s systems",
            display: true,
            order: 2
          },
          {
            name: "Ms. Kavitha Suresh Kumar",
            designation: "Principal Software Architect",
            organization: "Kyndryl India",
            expertise:
              "Generative AI in Software Development: From Code Generation to DevOps",
            display: false,
            order: 3
          }
        ]
      },
      moderator: {
        label: "Moderator",
        list: []
      }
    },

    /* -------------------------------------------------- */
    /* Track 3 — Panel Discussion */
    /* -------------------------------------------------- */
    {
      //slotId: "S9B",
      track: "Track 3",
      time: "02:30 – 03:45 PM",
      title: "Role of AI / ML in Defence Applications",
      format: "Panel Discussion + Interactive Session",
      description:
        "Panel discussion on the role of AI/ML in modern defence systems followed by audience interaction.",
      speakers: {
        label: "Distinguished Panelists",
        list: [
          {
            name: "Prof. Suresh Sundaram",
            designation:
              "Professor, Guidance & Control, Department of Aerospace Engineering",
            organization: "Indian Institute of Science (IISc), Bengaluru",
            expertise: "",
            display: false,
            order: 1
          },
          {
            name: "Dr. Manju Nanda",
            designation: "Chief Scientist",
            organization: "CSIR-NAL",
            expertise: "",
            display: true,
            order: 1
          },
          {
            name: "Dr. B Priestly Shan",
            designation: "Vice Chancellor",
            organization: "Alliance University",
            expertise: "",
            display: true,
            order: 2
          },
          {
            name: "Shri. J. V. Satyanarayana",
            designation: "Scientist 'H'",
            organization: "DRDO RCI",
            expertise: "",
            display: true,
            order: 3
          },
          {
            name: "Ms. R. Thogaivani",
            designation: "Scientist F",
            organization: "Flight Simulation Group ADE, DRDO",
            expertise: "",
            display: true,
            order: 4
          },
          {
            name: "Ms. Lakshmi Ravisankar",
            designation: "OS & Scientist",
            organization: "ADA",
            expertise: "",
            display: true,
            order: 5
          },
          {
            name: "Ms. Kavitha Suresh Kumar",
            designation: "Principal Software Architect",
            organization: "Kyndryl India",
            expertise: "",
            display: true,
            order: 6
          },
          {
            name: "Speaker from ADE",
            designation: "",
            organization: "ADE",
            expertise: "",
            display: false,
            order: 5
          },
          {
            name: "Speaker from BEL",
            designation: "",
            organization: "BEL",
            expertise: "",
            display: false,
            order: 6
          }
        ]
      },
      moderator: {
        label: "Chaired & Moderated By",
        list: [
          {
            name: "Dr B K Das",
            designation: "Distinguished Scientist",
            organization: "DG ECS DRDO",
            expertise: "",
            display: true,
            order: 1
          }
        ]
      }
    },

    /* -------------------------------------------------- */
    /* Break */
    /* -------------------------------------------------- */
    {
      time: "03:45 – 04:00 PM",
      title: "High Tea",
      format: "Break",
      description: "Networking refreshment break.",
      speakers: { label: "Speakers", list: [] },
      moderator: { label: "Moderator", list: [] }
    },
    /* -------------------------------------------------- */
    /* Track 4 — Invited Talks */
    /* -------------------------------------------------- */
    // {
    //  // slotId: "S9A",
    //   track: "Track 4",
    //   time: "02:00 – 03:15 PM",
    //   title: "Cybersecurity & Trustworthy AI for Defence and Space",
    //   format: "Invited Talks",
    //   description:
    //     "Invited talks on trustworthy AI, space cybersecurity, and emerging cyber threats to defence systems.",
    //   speakers: {
    //     label: "Invited Speakers",
    //     list: [
    //       {
    //         name: "Ms. Pooja Yadav",
    //         designation: "Scientist SAG",
    //         organization: "DRDO",
    //         expertise:
    //           "Challenges & Risks to Trustworthy AI in Military Systems",
    //         display: true,
    //         order: 1
    //       },
    //       {
    //         name: "Shri. Sujith S",
    //         designation: "Sci/Eng-G, Group Director, CITG, MSA",
    //         organization: "VSSC",
    //         expertise: "Safeguarding Space from Cyber Shadows",
    //         display: true,
    //         order: 2
    //       },
    //       {
    //         name: "Ms. Navya Iyengar",
    //         designation: "Managing Partner",
    //         organization: "LNN Evara Advisors",
    //         expertise:
    //           "The Quantum-AI Death Trap: Future Cyber Risks to India’s Defence Assets",
    //         display: true,
    //         order: 3
    //       }
    //     ]
    //   },
    //   moderator: {
    //     label: "Moderator",
    //     list: []
    //   }
    // },

    /* -------------------------------------------------- */
    /* Track 4 — Panel Discussion */
    /* -------------------------------------------------- */
    {
      // slotId: "S9B",
      track: "Track 4",
      time: "04:00 – 05:15 PM",
      title: "Battlefield & Space Cybersecurity",
      format: "Panel Discussion + Interactive Session",
      description:
        "Panel discussion on cybersecurity challenges across battlefield and space domains with audience interaction.",
      speakers: {
        label: "Distinguished Panelists",
        list: [
          {
            name: "Shri. Sujith S",
            designation: "Sci/Eng-G, Group Director, CITG, MSA",
            organization: "VSSC",
            expertise: "",
            display: true,
            order: 1
          },
          {
            name: "Ms. Pooja Yadav",
            designation: "Scientist SAG",
            organization: "DRDO",
            expertise: "",
            display: true,
            order: 2
          },
          {
            name: "Shri. Peeyush Marwaha",
            designation: "Global Shared Services Head, CSRM",
            organization: "Tech Mahindra",
            expertise: "",
            display: true,
            order: 3
          },
          {
            name: "Shri. Ashok Sharma",
            designation: "",
            organization: "",
            expertise: "",
            display: true,
            order: 4
          },
          {
            name: "Ms. Navya Iyengar",
            designation: "Managing Partner",
            organization: "LNN Evara Advisors",
            expertise: "",
            display: true,
            order: 5
          },

        ]
      },
      moderator: {
        label: "Chaired & Moderated By",
        list: [
          {
            name: "Ms. Suma Varughese",
            designation: "Former DG – MED, CoS & CS (MCC)",
            organization: "DRDO",
            expertise: "",
            display: true,
            order: 1
          }
        ]
      }
    }
    ,

    /* -------------------------------------------------- */
    /* Closing */
    /* -------------------------------------------------- */
    {
      time: "05:15 – 05:30 PM",
      title: "Closing Remarks & Vote of Thanks",
      format: "Closing Session",
      description: "Summation of the conclave and acknowledgements.",
      speakers: { label: "Speakers", list: [] },
      moderator: { label: "Moderator", list: [] }
    }
  ]


};
